const zh_CN = {
  // 共用區
  tag_name: '标签名称',
  property: '属性',
  endpoint: '终端',
  protocol: '协议',
  parameters: '参数',
  items: '{item}',
  delete_msg: '您确定要删除此{item}吗？',
  this_field_is_required: '此字段必填',
  external_address: '外部地址',
  internal_address: '内部地址',
  port: '端口',
  name_validate_error_msg: '只允许 0-9 a-z A-Z . _ 和 -',
  edit: '编辑',
  name: '名称',
  description: '描述',
  created_time: '创建时间',
  status: '状态',
  delete: '删除',
  please_select_service: '请选择服务',
  management: '管理中心',
  console: '工作台',
  lang: '语言',
  catalog: '应用商店',
  address: '地址',
  alternative_email: '备用邮箱',
  billing: '费用',
  cluster: '集群',
  city: '城市',
  company: '公司',
  config: '配置',
  confirm: '确定',
  contact_phone: '联系电话',
  contact_technical_support: '联系技术支持',
  country_region: '国家/地区',
  create: '创建',
  create_time: '创建时间',
  delete_role: '确定要删除此角色吗？',
  delete_roles: '确定要删除这些角色吗？',
  delete_user: '您确定要删除{name}吗？',
  disabled: '禁用',
  delete_item: '删除{type}',
  enabled: '启用',
  delete_service: '删除服务',
  empty: '空',
  first_name: '名字',
  highest_role: '最高权限',
  industry: '行业',
  invite: '邀请',
  last_login: '上次登录',
  home: '主页',
  last_name: '姓氏',
  license_invalid: '无效的许可证或许可证已过期',
  loading: '加载中',
  namespace: '命名空间',
  not_login: '尚未登录',
  order: '订单',
  path: '路径',
  p_s_rc: '请选择国家或地区',
  quota: '配额',
  resources_mgmt: '资源管理',
  resources_permission_exist: '资源权限已存在',
  role_permission_exist: '角色权限已存在',
  resource_permissions_sub: '创建、分配和管理用户资源权限和角色',
  role: '角色',
  rules: '规则',
  save: '保存',
  select_role: '请选择角色',
  service: '服务',
  services: '服务',
  service_property: '服务属性',
  services_list: '显示各应用组中的服务列表及详细信息，服务注册，服务地址是否暴露至公共服务列表和服务健康检查等功能。',
  success_save: '保存成功',
  support_message: '如果您遇到问题需要技术支持，请发送电子邮件至',
  source: '来源',
  stop: '停止',
  tickets: '工单',
  type: '类型',
  user_base_info: '用户基本信息',
  user_center: '用户中心',
  user_info: '用户信息',
  user_info_sub: '用户的基本信息和权限',
  username: '用户名',
  workspace: '工作空间',
  resource: '资源',
  add: '添加',
  events: '事件',
  refresh: '刷新',
  remember_me: '记住我',
  search: '搜索',
  subscription_name: '订阅号名称',
  total_items: '共 {value} 条',
  user: '用户',
  view: '查看',
  activation_code: '激活码',
  back: '返回',
  bind: '绑定',
  bind_sso: '绑定 EnSaaS SSO 帐号',
  change: '修改',
  change_pwd: '更改密码',
  change_pwd_sub: '首次更改登录密码，请参考密码字符',
  confirm_info: '「确认」点击确认即表示您同意创建SSO账号',
  create_info:
    '我们将为您生成一组EnSaaS SSO 帐号并与您的MyAdvantech 帐号绑定在一起，EnSaaS 订阅号与MyAdvantech Account 绑定。绑定后，您将收到一封EnSaaS SSO 帐号注册信，请根据注册信中的提示登录 EnSaaS Portal 并修改您的密码。',
  creation_time: '创建时间',
  delete_users: '您确定要删除这些用户吗？',
  disable: '禁用',
  disable_user: '您确定要禁用此用户吗？',
  disable_users: '您确定要禁用这些用户吗？',
  enable: '启用',
  enable_user: '您确定要启用此用户吗？',
  enable_users: '您确定要启用这些用户吗？',
  export: '导出',
  help: '帮助',
  id: 'ID',
  member: '成员',
  node_type: '节点类型',
  or_sign_in_with: '或登录用',
  origin: '来源',
  password_error: '密码错误',
  password_check_email: '请查看邮件，输入正确的密码',
  p_c_pwd: '请检查密码',
  p_i_activation_code: '请输入激活码！',
  p_i_password: '请输入密码',
  p_i_phone: '请输入手机号码',
  p_i_n_pwd: '请输入新密码',
  p_i_n_pwd_a: '请再次输入新密码',
  pwd_policy: '密码规则',
  pwd_p_1: '至少8个字符',
  pwd_p_2: '至少1位数',
  pwd_p_3: '至少1个小写字母',
  pwd_p_4: '至少1个大写字母',
  pwd_p_5: '至少1个特殊字符',
  pwd_p_6: "除了空格（），反斜杠（\\）和双引号（“）'）",
  retry: '重试',
  reset: '重置',
  resend_code: '重新发送验证码',
  resend_email: '重新发送邮件',
  resend_email_info:
    '如果您在注册完成后仍未收到注册电子邮件，则可以使用此工具重新发送。 提交后，您将收到一封电子邮件，其中包含完成该过程的链接。要重新发送注册电子邮件，请输入您的用户名（Email），然后单击“提交”。',
  resend_email_sub: '输入电子邮件以重新发送注册电子邮件',
  resend_email_success: '成功重新发送注册电子邮件。 页面将在5秒钟后跳转。',
  reset_pwd_valid: '重置密码有效',
  reset_pwd_success: '更改密码成功。',
  send_pwd_email_success: '成功发送密码重置电子邮件。 页面将在5秒钟后跳转。',
  select_dc: '请选择数据中心',
  select_cluster: '请选择集群',
  select_ws: '请选择工作空间',
  select_ns: '请选择命名空间',
  setting: '设置',
  success: '成功',
  submit: '提交',
  subscription: '订阅号',
  subscription_info: '订阅号信息',
  subscriptions: '订阅号',
  system_notification_sub: '由于是首次登录，我们建议您立即更改默认密码。',
  two_pwd_unequal: '您输入的两个密码不一致！',
  update: '更新',
  user_id: '用户ID',
  username_email: '用户名(邮箱)',
  verify: '验证',
  version: '版本',
  warning: '警告',
  web_kubectl: 'Web Kubectl',
  all: '全部',
  cancel: '取消',
  cpu: 'CPU',
  memory: '内存',
  content: '内容',
  backup_restore: '备份还原',
  products: '服务目录',
  update_time: '更新时间',
  secret: '密钥',
  value: '值',
  operation_type: '操作类型',
  operation_records: '操作记录',
  action: '操作',
  pn: '料号',
  dataCenter: '站点',
  no_data: '没有数据',
  please_input: '请输入{type}名称',
  ingress: 'Ingress',
  batch_assign: '批量映射',
  notification: '通知',
  send_verify_code: '发送验证码',
  p_i_first_name: '请输入名字',
  p_i_last_name: '请输入姓氏',
  verify_code: '验证码',
  whitelist: '白名单',
  remove: '移除',
  batch_delete: '批量删除',
  successfully: '成功',
  error: '失败',
  created: '创建',
  updated: '更新',
  deleted: '删除',
  operator: '操作者',
  'please_input_ ': '请输入',

  // 列表表格
  //   refresh: '刷新',
  //   all: '全部',
  // please_input: '请输入{type}名称',

  // 彈窗
  ok: '确定',
  // cancel: '取消',
  operation: '操作',
  this_name_has_been_existed: '此名称已存在',
  //   name_validate_error_msg: '只允许 0-9 a-z A-Z . 和 -',
  should_not_be_at_the_beginning_or_end: '特殊字符 .- 不能在名称开头或结尾',

  // 登录页面
  /*
  registered: '注 册',
  registered_title: '注 册',
  registered_success: '注册成功！',
  sign_in: '登录',
  forgot_pwd: '忘记密码',
  retrieve_password: '找回密码',
  retrieve_password_sub: '输入您的电子邮件地址。稍后将发送验证码。',
  r_to_login: '返回登录页面',
  p_i_username_e: '请输入用户名（电子邮件）',
  send_pwd_email: '发送密码重置电子邮件',
  send_pwd_email_sub: '如果您忘记了密码，您可以使用此工具重置密码。提交后，您将收到一封电子邮件验证码，并包含完成该过程的链接。',
  sign_in_sub: '登录到开发人员网络',
  skip: '跳过',
  go_to_change_pwd: '转到更改密码',
  system_notification: '系统通知',
  password: '密码',
  p_i_pwd: '请输入您的密码',
  p_i_username: '请输入您的用户名',
  not_receive_email: '未收到电子邮件',
  draft: '草稿',
  release: '发布',
  services_name: '服务名称',
  beta_backends: '灰度发布后端',
  Description: '描述',
  versionhistory: '版本历史记录',
  please_select_config: '请选择配置',
  please_select_service_name: '请选择服务名称',
  portservices: ' 端口服务',
  // please_select_service: "请选择服务",
  Method: '方法',
  Path: '路径',
  appgroup: '应用组',
  generate_token: '生成令牌',
  true: '真',
  config_description: '配置说明',
  enable_auto_delete: '启用自动删除',
  expose_service_address: '暴露服务地址',
  service_address: '服务地址',
  write_able: '可写',
  please_select_cluster: '请选择集群',
  please_select_namespace: '请选择命名空间',
  please_select_workspace: '请选择工作区',
  api_versions: 'API 版本',
  service_infos: '服务信息',
  writable: '可写入',
  workload_name: '工作负载名称',
  namespace_name: '命名空间名称',
  name_length_range: '名称支持{range}字符',
  cluster_name: '集群名称',
  roll_back: '回滚',
  enable_service_address: '启用服务地址',
  enable_autodelete: '启用自动删除',
  workload_type: '工作负载类型',
  auth_token: '身份验证令牌',
  // cluster: "集群",
  datacenter: '数据中心',
  // namespace: "命名空间",
  // log_out: "退出登录",
  // no_data: '没有数据',
  services_address: '服务地址',
  */
  pwd_rule_prompt_and_desc: '密码规则提示和说明',
  return_to_log_in: '返回登录',
  enter_email_to_reset_pwd: '输入电子邮件以重置密码',
  reset_pwd: '重置密码',
  forget_pwd: '忘记密码',
  back_to_login: '已经有帐户了吗？登录',
  email_address: '电子邮件地址',
  or_third_party: '或',
  sign_up_text: '注册帐户',
  u_n_or_p_w_d_error: '用户名或密码不正确。',
  login_app_name: 'WISE-IoTSuite/MP',
  log_in_sub: '登录到 {name}',
  registered: '注 册',
  registered_title: '注 册',
  registered_success: '注册成功！',
  sign_in: '登录',
  forgot_pwd: '忘记密码',
  retrieve_password: '找回密码',
  retrieve_password_sub: '输入您的电子邮件地址。稍后将发送验证码。',
  r_to_login: '返回登录页面',
  p_i_username_e: '请输入用户名（电子邮件）',
  send_pwd_email: '发送密码重置电子邮件',
  send_pwd_email_sub: '如果您忘记了密码，您可以使用此工具重置密码。提交后，您将收到一封电子邮件验证码，并包含完成该过程的链接。',
  sign_in_sub: '登录到开发人员网络',
  skip: '跳过',
  go_to_change_pwd: '转到更改密码',
  system_notification: '系统通知',
  password: '密码',
  p_i_pwd: '请输入您的密码',
  p_i_username: '请输入您的用户名',
  not_receive_email: '未收到电子邮件',
  draft: '草稿',
  release: '发布',
  services_name: '服务名称',
  beta_backends: '灰度发布后端',
  Description: '描述',
  versionhistory: '版本历史记录',

  portservices: ' 端口服务',

  Method: '方法',
  Path: '路径',
  appgroup: '应用组',
  generate_token: '生成令牌',
  true: '真',
  config_description: '配置说明',
  enable_auto_delete: '启用自动删除',
  expose_service_address: '暴露服务地址',
  service_address: '服务地址',
  write_able: '可写',

  api_versions: 'API 版本',
  service_infos: '服务信息',
  writable: '可写入',
  workload_name: '工作负载名称',
  namespace_name: '命名空间名称',
  name_length_range: '名称支持{range}字符',
  cluster_name: '集群名称',
  roll_back: '回滚',
  enable_service_address: '启用服务地址',
  enable_autodelete: '启用自动删除',
  workload_type: '工作负载类型',
  auth_token: '身份验证令牌',
  // cluster: "集群",
  datacenter: '数据中心',
  // namespace: "命名空间",
  // log_out: "退出登录",
  // no_data: '没有数据',
  services_address: '服务地址',
  // phone: '手机',

  // Top Navbar

  // a
  add_user: '添加用户',

  // b
  billing_portal: '计费中心',

  // c
  top_console: '工作台',
  // cancel: "取消",
  // confirm: "确定",
  // contact_technical_support: "联系技术支持",

  // h
  hi: '您好，',

  // l
  log_out: '退出登录',
  log_in: '登录',

  // m
  management_portal: '管理中心',

  // p
  // please_input: '请输入{type}名称',

  // s
  // services: "服务",
  // support_message: "如果您遇到问题需要技术支持，请发送电子邮件至",
  // subscription_name: "订阅号名称",
  service_portal: '服务中心',

  // t
  themes: '主题',
  // tickets: "工单",
  ticket_portal: '工单中心',

  // u
  units: '单位',
  // user_center: "用户中心",

  // desc
  mp_desc:
    '管理中心是 EnSaaS K8s Service 的控制台，EnSaaS K8s Service 基于 Kubernetes 为用户提供了开箱即用的微服务框架、企业级的容器管理平台、多层级的租户工作空间以及一致性的基础设施封装，为应用提供了全生命周期管理。',
  sso_desc:
    '用户中心是 WISE-PaaS 为用户提供的一套安全，便捷，开放的统一身份认证服务，包括用户身份管理、企业帐号管理、客户端管理等功能，支持单点登录，以及灵活的应用整合方式。',
  service_desc:
    '服务中心是 PostgreSQL、MongoDB、InfluxDB 等多元数据库、RabbitMQ 消息中间件、AIFS 等所有托管服务实例的控制台。服务中心提供了数据库访问以及设备接入平台的密钥创建、更新、删除等全生命周期管理功能以及便捷的操作界面。',
  bill_desc: '计费中心即费用中心，用户可以实时查看订单状态、交易明细、服务价格与会员折扣，以及月账单等信息。',
  ticket_desc: '工单中心为平台用户在线解决各种问题。所有订阅号用户均可以透过此系统创建问题工单，技术支持工程师将根据问题类别与情况逐一处理。',
  container: 'Container',

  // =======================           Buy Portal           =======================
  // management: "管理中心",
  // console: "工作台",
  // lang: "语言",
  // catalog: "应用商店",
  // billing: "费用",
  // tickets: "工单",
  // order: "订单",
  document: 'Document',
  blue: 'blue',
  sign_out: '登出',
  available_day: '购买时长',
  // user_center: "用户中心",
  next: '下一步',
  // confirm: "确定",
  // cancel: '取消',
  previous: '上一步',
  // contact_technical_support: "联系我们",
  // support_message: "如果您遇到技术支持问题，请发送电子邮件至",
  trouble_message: '如果您想排除故障，请发送电子邮件至',

  // =======================           EnSaaS Service Mesh Portal           =======================

  delete_batch_backend_info: '您确定要删除已选中的离线后端实例吗？',
  delete_all_offline_backend_info: '是否要删除该服务的所有离线后端服务实例？',
  agent_update: 'Agent Update',
  agent_update_list: 'List all the information of Config Mgmt. Agents. There is only one agent in each cluster. Users could select the agent to update.',
  container_update: 'Container更新',
  reg_release: '发布',
  service_image_name: '服务镜像名称',
  sidecar_updatable: 'Sidecar是否可升级',
  service_image: '服务镜像',
  images: '镜像',
  init_images: '初始化镜像',
  update_sidecar: '更新Sidecar',
  delete_all_backend_info: '确定删除选中的后端实例吗？',
  beta: '灰度发布',
  tag_name_exist: '标签名已存在',
  unbindabled: '解绑',
  bindabled: '绑定',
  config_edit: '更新配置',
  import_config: '导入配置',
  config_management: '配置管理',
  // config: "配置",
  configs: '配置',
  config_list: '配置可存储各应用内部所需的环境变量信息，分为公有配置和私有配置，',
  public_config_desc: '所有应用组的公有配置。',
  private_config_desc: '私有配置属于某一个应用组，该应用组内的服务都可以访问应用组内的私有配置。',
  // empty: "空",
  // version: "版本：",

  // 左側選單
  groups: '组',
  app_groups: '应用组',
  app_group_list: '共享某些配置或者功能类似的一组应用的合集被称为一个应用组。',
  version_history: '版本历史记录',
  version_history_list: '配置信息的历史版本管理，支持回滚到最新版本之前的某一个历史版本；保存历史版本数量上限为为应用组历史版本数量上限值。',
  listening_management: '监听管理',
  listening_management_list: '可以查询使用sdk监听配置变化的后端应用；支持以配置和后端为维度的配置监听查询。',
  group_management: '应用组管理',
  registry: '注册 表',
  service_management: '服务管理',
  backends: '后端实例',
  backends_list: '后端服务实例（如pod）的状态显示以及编辑操作。',
  service_authentication: '服务身份验证',
  port_service: ' 端口服务',
  port_services_list: '每个服务含有一个或多个服务端口，端口服务管理显示每个服务端口所对应的具体子服务信息。',
  // service: "服务",
  traffic_management: '流量控制',
  user_management: '用户管理',
  distributed_tracing: '分布式跟踪',
  // table-list 列表
  // edit: "编辑",
  // delete: "删除",
  expose: '暴露',
  import: '导入',
  watch: '看',
  view_service_registry_information: '查看服务注册表信息',
  view_group_information: '查看应用组',
  // whitelist: '白名单',
  auth_filter: '身份验证过滤器',
  resource_filter: '资源筛选器',
  view_port_services: '查看端口服务',
  view_backends: '查看后端',
  app_group: '应用组',
  app_grou: '应用组',
  view_history_information: '查看历史记录',
  history_information: '历史信息',
  view_token: '更新服务配置',
  token_information: '服務配置信息',
  // loading: "加载。。。",
  // Services
  service_name: '服务名称',
  service_registry: '服务注册',
  // created_time: "创建时间",
  service_instance_id: '服务实例 ID',
  subscription_id: '订阅 ID',
  updated_time: '更新时间',
  time_stamp: '时间',
  service_registry_information: '服务注册表信息',
  total_pod: '总 pod',
  ready_pod: '就绪 pod',
  pod_names: '窗格名称',
  // create_time: "创建时间",
  // App Groups
  app_group_name: '应用组名称',
  app_group_id: '应用组 ID',
  // description: "描述",
  salt: '盐',
  // quota: "配额",
  // name: "名字",
  config_quantity: '配置数量',
  backend_quantity: '后端数量',
  enable_tracing: '启用跟踪',
  config_name: '配置名称',
  format: '格式',
  // tag_name: '标签名称',
  // type: "类型",
  is_beta_release: '灰度发布',
  release_status: '发布状态',
  public_bindable: '公共绑定',
  beta_release: '灰度发布',
  stop_beta: '停止灰度发布',
  //port services
  portServiceName: '端口服务名称',
  internalAddress: '内部地址',
  externalAddress: '外部地址',
  svcAddress: 'Svc 地址',
  // port: "港口",
  targetPort: '目标端口',
  please_select_port_service: '请选择端口服务',
  // please_select_service: "请选择服务",
  please_select_app_group: '请选择应用组',
  // rules: "规则",
  skip_rules: '跳过规则',
  skip_rule: '跳过规则',
  format_is_not_valid: '[格式] 无效',
  // name_validate_error_msg: "只有 a-z， 0-9 。和 - 允许",
  // Resource Permission Management
  // resource_permissions_sub: "创建、分配和管理用户资源权限和角色",
  // resource_permissions: "用户权限",
  // highest_role: "最高角色",
  // last_login: "上次登录",
  // last_name: "姓氏",
  // status: "地位",
  group_status: '组状态',
  select_app_group: '选择应用组',
  // user_info: "用户信息",
  // user_info_sub: "用户的基本信息和权限",
  // username: "用户",
  // first_name: "名字",
  // alternative_email: "替代电子邮件",
  // contact_phone: "联系电话",
  // industry: "行业",
  // country_region: "国家/地区",
  // company: "公司",
  // address: "地址",
  // city: "城市",
  // user_base_info: "用户的基本信息",
  office_phone: '办公室电话',
  avatar: '化身',
  postal_code: '邮政编码',
  // resources_mgmt: "资源管理",
  // role: "作用",
  // select_role: "选择角色",
  // p_s_rc: "请选择一个或一个或一个",
  // workspace: "工作",
  data_center: '数据中心',
  // invite: "邀请",
  // delete_role: "是否确实要删除此角色？",
  // resources_permission_exist: "资源权限已存在",
  admin_resources_permission_exist: '管理员权限已存在，不添加其他权限',
  admin_role_permission_exist: '管理员角色权限已存在，不添加其他权限',
  admin_permission_delete_other: '如果您添加管理员权限，其他权限将被删除',
  admin_role_delete_other: '如果您添加管理员角色，其他权限将被删除',
  role_not_insert: '角色未插入',
  // delete_roles: "是否确实要删除这些角色？",
  // success_save: "已成功保存",
  success_add: '已成功添加',
  role_name: '角色名称',
  // delete_user: "是否确实要删除此用户？",
  // not_login: "尚未登录",
  target_port: '目标端口',
  svc_address: 'Svc 地址',
  // internal_address: "内部地址",
  // external_address: "外部地址",
  delete_service_address: '您确定要从公共服务地址中删除此服务地址吗？',
  // save: "保存",
  description_config: '描述',
  white_list: '白名单',
  add_rules: '添加规则',
  add_skip_rules: '添加跳过规则',
  add_skip_rules_all: '添加跳过规则全部',
  add_env_var: '添加环境变量',
  add_arg: '添加阿古姆内特',
  group_basic_infomation: '组基本信息',
  backend_name: '后端名称',
  listen_start_time: '侦听开始时间',
  push_config_time: '推送配置时间',
  is_successful: '成功',
  dimension_config: '配置', //Query Dimension:
  dimension_ip: '后台',
  dimension: '维度',
  please_select_dimension: '请选择尺寸',
  enable_white_list: '启用白名单',
  add_white_list: '添加白名单',
  rate_limit: '费率限制',
  circuit_breaker: '断路器',
  port_service_name: '端口服务名称',
  method: '方法',
  // path: "路径",
  period: '时期',
  rate_limit_value: '流量限制值',
  enable_rate_limit: '启用流量限制',
  invite_user: '邀请用户',
  add_rate_limit: '添加流量限制',
  port_services_name: '端口服务名称',
  // protocol: '协议',
  api_version: 'API 版本',
  load_balancing: '负载平衡',
  max_connections: '最大连接',
  max_pending_requests: '最大待定请求',
  max_requests: '最大请求数',
  max_retries: '最大重试次数',
  resource_role_API: '资源角色 API',
  group_basic_information: '组基本信息',
  history_version_quantity: '历史记录版本数量',
  config_size_kb: '配置大小(KB)',
  // id: "配置 ID",
  rateLimitValue: '速率限制值',
  please_select_port_service_name: '请选择端口服务名称',
  flowcontrol: '流量控制',
  offline_time: '离线时间',
  auto_delete_time: '自动删除时间',
  delete_sidecar: '删除sidecar',
  sidecar: 'sidecar',
  canary: '金丝雀',
  main_weight: '主重量',
  mainWeight: '主重量',
  canary_weight: '金丝雀重量',
  canaryWeight: '金丝雀重量',
  container_name: '容器名称',
  containerName: '容器名称',
  image: '图像',
  replace_env: '替换环境变量',
  replaceEnv: '替换环境变量',
  replace_args: '替换参数',
  replaceArgs: '替换参数',
  env: '环境变量',
  arg: '参数',
  enable_resource_role: '启用资源角色',
  enable_authentication: '启用身份验证',
  enable_canary: '启用金丝雀',
  has_sidecar: '有sidecar',
  config_id: '配置 ID',
  please_select_backend_name: '请选择后端名称',
  view_service: '查看服务',
  enable_service_auth: '启用服务身份验证',
  sso_auth_filter: 'SSO 身份验证过滤器',
  ensaas_role_filter: 'EnSaaS 角色筛选器',
  // disabled: "禁用",
  is_disabled: '已启用',
  access_token: '访问令牌',
  config_names: '配置名称',
  token: '令牌',
  all_user: '所有用户',
  admin: '管理',
  app_group_owner: '应用程序组所有者',
  numbers_only: '仅数字',
  // service_infos: "服务信息",
  // generate_token: "生成令牌",
  // services_name: "服务名称",
  // Description: "描述",
  // expose_service_address: "公开服务地址",
  // enable_auto_delete: "启用自动删除",
  // appgroup: "应用组",
  appgrou: '应用组',
  // config_description: "配置说明",
  // draft: "草案",
  // release: "释放",
  // please_select_config: "请选择配置",
  // please_select_service_name: "请选择服务名称",
  // roll_back: "回滚",
  // versionhistory: "版本历史记录",
  // workload_name: "工作负载名称",
  // namespace_name: "命名空间名称",
  // cluster_name: "集群名称",
  portservice: ' 端口服务',
  // please_select_service: "请选择服务",
  backend: '后台',
  // username_email: "用户名电子邮件",
  // skip: "跳",
  // namespace: "Namespace",
  // cluster: "集群",

  restart_backends: '重启后端',
  edit_sidecar: '编辑sidecar',
  restart_backends_tip: '重启所有后端',
  ephemeral_storage: '临时存储',
  requests: '要求',
  limits: '限制',
  config_editing: '编辑中',
  current_config: '当前配置',
  backends_information: '后端实例信息',
  is_initialized: '是否初始化',
  is_canary: '是否是金丝雀',
  enbal_tracing: '启用跟踪',
  ip: 'IP',
  service_location: '服务位置',

  global: '首页',
  requests_or_limits_one_field_is_required: '要求和限制必填',
  sidecar_injected: 'sidecar是否注入',
  del_config: '配置',
  public_config_delete_info: '注意: 此操作将会删除所有的配置信息!',
  config_type: '配置类型',
  tag_description: '标签描述',
  requests_limits: '要求必须小于等于限制',
  export_config_tip: '确定导出吗?',
  file_is_invalidate: '内容无效',
  workloads_list: '服务注册功能，将工作负载注入到sidecar中。',
  license_invalid_after: '许可证将于',
  n_days: ' 天后过期',
  license_invalid_immediately: '许可证即将失效',
  please_select_config_type: '请选择配置类型',
  user_permission: '用户权限',
  is_inject: 'sidecar是否注入',
  workload: '工作负载',
  workloads: '工作负载',
  role_mgmt: '角色管理',
  global_auditor: '全局审计者',
  token_path_info1: '提示：请按照以下格式将token值填入您的服务部署文件的metadata.annotations中：',
  token_path_info2: 'ensaas.k8s.io/accesstoken: <token value>',
  service_address_desc: '公共服务地址列表：当注入Sidecar选择暴露服务地址选项时，服务的地址将会在此显示',
  sidecar_is_inject: 'Sidecar已经注入',
  roll_back_to: '确定回滚到 {item} 吗?',
  active_backends: '在线后端实例',

  // =======================           Tunnel Server           =======================

  // 客户端管理
  clients: '客户端',
  clients_desc: '客户端可以位于一个集群，容器，虚拟机，或物理机，用于与映射服务端通信。建立映射前，您需要先有至少一个客户端',
  client: '客户端',
  detail: '详细信息',
  // delete_msg: '您确定要删除此{item}吗？',
  please_input_tunnel: '请输入{type}名称',
  client_ip: '客户端 IP',
  deploy_file: '部署文件',
  deploy_guide: '部署指南',
  client_hint: `### **操作提示**
  当您添加完客户端，只是进行了客户端信息的创建，您还需要部署客户端实体。请点击客户端右侧操作 -> 详情，查看客户端详细信息，并根据详情中的教学，进行客户端的部署`,
  deploy_doc: `### **使用 Deployment 部署**
  1. 点击部署文件左侧的展开按钮，可以查看部署文件。
  2. 点击右侧的下载按钮，可以下载部署文件。下载的文件名称默认为：<客户端名称>.yml
  3. 进入步骤2中下载部署文件目录，执行以下命令，即完成客户端的部署。注意更改为您的部署文件名称和命名空间名称

  \`$ kubectl apply -f <部署文件名称>.yml -n <命名空间名称>\`
  `,
  import_doc1: `根据您的环境，下载获取 token 的脚本。当前支持 `,
  import_doc2: `。`,
  import_doc3: `2. windows 下载的文件保存为 \\<文件名\\>.bat，linux 下载的文件保存为 \\<文件名\\>.sh
  3. 运行步骤 2 中的脚本，即可获取到 token 和 server。`,
  import_doc4: '4. 将 ---- 中间部分的内容拷贝到下面的输入框中（包含 token 和 host 信息），页面会自动识别出 token 和 server 填入映射信息对应的输入框中。',

  // 内网映射
  tunnels: '内网映射',
  tunnels_desc: '映射可以用于内网穿透，外网可以通过映射提供的域名，随时随地访问内网搭建的服务',
  a_type_must_be_selected: '必须选择{type}',
  mapping_type: '映射类型',
  mapping_info: '映射信息',
  port_err: '仅接受数字 （0-65535）',
  ip_err: '请输入有效的 IP',
  hostname_err: '仅允许 0-9 a-z A-Z -',
  hostname_err_internal: '仅允许 0-9 a-z A-Z . 和 -',
  tunnel: '内网映射',
  type_card: '{type}：',
  cluster_info: '集群信息',
  cluster_token: '集群令牌',
  access_address: '访问地址',
  external_server_card: '{access_address}：',
  internal_server: '内部服务器',
  internal_server_card: '{internal_server}：{internal_addr}',
  cluster_host: '集群主机',
  //   web_kubectl:'在线 Kubectl',
  copy: '复制',
  download_tunnel: '下载',
  certificate: '证书',
  key_tunnel: '密钥',
  root_certification: '根证书',
  diagnosis: '诊断',
  diagnosis_info: `**{name}**

  诊断域名：{domain}
  转发服务器 IP：{forward_server_ip}
  映射：{dns_ip}
  局域网服务器：{internal_server_address}
  本机内网 IP：{internal_server_ip}
  代理 IP：{agent_ip}
  {status}`,
  view_help: '查看帮助',
  get_token: '获取令牌',
  code1000: '域名已激活内网穿透功能，并与转发服务器 IP 指向一致，连接转发服务器成功',
  code1001: '内网映射的外部域名解析错误，域名没有激活内网透传功能',
  code1002: '内网映射的客户端离线',
  code1003: '内网映射的服务器和代理之间创建连接失败',
  code1004: '局域网服务器连接失败',
  // ingress: 'Ingress',
  // batch_assign: '批量映射',

  // Security Settings
  security_settings: '安全设置',
  // whitelist: '白名单',
  client_whitelists: '客户端白名单',
  type_whitelists: '{type}白名单',
  // remove: '删除',
  move_up: '上移',
  move_down: '下移',
  ip_address: 'IP 地址',

  // =======================           Bill Portal          =======================

  //type: '类型',
  //company: '公司',
  //status: '状态',
  //service: '服务',
  // subscription_name: "订阅号名称",
  subscriptionName: '订阅号名称',

  orderId: '订单号',
  subscriptionId: '订阅号',
  transactionId: '交易号',
  createdAt: '创建时间',
  activedAt: '激活时间',
  orderSource: '订单来源',
  serviceName: '服务名称',
  serviceCategory: '服务分类',
  plan: '产品规格',
  partNumber: '料号',
  isPaidAccount: '付费账户',
  time: '起止时间',
  // pn: '料号',
  identity: '您的身份是',
  here_is: '这是您的总会员价',
  totalProratedPrice: '总价',
  orderStatus: '订单状态',
  activated_at: '开通时间',
  ended_at: '到期时间',
  actions: '操作',
  view_details: '查看详情',
  all_reset: '一键清空',
  totalListingPrice: '总牌价',
  totalMemberPrice: '总会员价',
  total_Prorated_Price: '总比例价',
  totalListingProratedPrice: '总牌价比例价',
  totalDiscountPrice: '总折扣价',
  currency_unit: '货币单位',
  deduction: '扣款类型',
  notice_tip: '选择关闭后，将默认您已阅读该公告并且下次不会再显示，请知悉！',
  crmId: '企业号',
  // dataCenter: '站点',
  wiseType: '会员身份',
  prepaidServiceCharges: '预付费原价',
  prepaidMemberDiscounts: '预付费折扣',
  postpaidUsageCharges: '按量后付费原价',
  postpaidMemberDiscounts: '按量后付费折扣',
  totalCharges: '应付总额',
  total: '总应付额',
  totalPostpaidMemberDiscounts: '总按量后付费折扣',
  totalPostpaidUsageCharges: '总按量后付费原价',
  totalPrepaidMemberDiscounts: '总预付费折扣',
  totalPrepaidServiceCharges: '总预付费原价',
  bill_tip: '当月最终消费汇总将在次月初生成，在次月4日10点后可查看和导出，请您届时关注。',
  Bill: '账单',
  Order: '订单',
  bill_cycle: '账单月份',
  time_period: '时间',
  discount_rate: '折扣率',
  export_content: '导出内容：',
  current_list: '当前查询条件下的列表',
  current_unit: '导出的货币单位：',
  export_bill: '导出账单列表(CSV)',
  export_order: '导出订单列表(CSV)',
  crmIdName: '企业号名称',
  exchangeRateDiscount: '汇率',
  serviceCharges: '原价',
  memberDiscounts: '折扣',
  charges: '按量总额',
  payg_details: '按量详情',
  // =======================           Catalog Portal          =======================
  //admin: '管理员',
  //catalog: '目录',
  //go_to_change_pwd: '修改密碼',
  //loading: '加载中。。。。。。',
  //not_receive_email: '没有收到注册邮件吗？',
  //role: '角色',
  //sign_in_sub: '登入用WISE PaaS EnSaaS SSO账号',
  //username: '用户名',
  // a
  // action: '操作',
  // add: "添加",
  add_catalog: '添加目录',
  add_project: '添加项目',
  // add_user: "添加用户",
  admin_theme_name: 'admin 账号管理',
  admin_theme_subname: '账号管理系统管理员用此功能模块管理账号，如创建、更新、读取、删除admin账号等',
  admin_account: 'Admin 账户',
  apps_info: 'Apps 详情',
  apps_info_content: '用户可以看到添加的Apps地址下，所包含的所有App，并进行查看与部署',
  app_version: 'App 版本',

  // b
  back_to_list: '返回列表',
  basic_info: '基础信息',

  // c
  catalog_info: '目录详情',
  catalog_number: 'catalog 数量',
  create_project: '创建项目',
  create_admin: '创建 admin',
  charts: 'Charts',
  chart_version: 'Chart 版本',
  create_retry: '创建SSO账号失败，请重试！',
  create_success: '创建SSO账号成功，点击确认进入EnSaaS Portal或登录邮箱。',
  confirm_login: '你还没有登录，确定现在要登录吗？',
  condition_acount_type: '即日起，开放企业帐号管理机制申请渠道。会员类型为VIP及以上可以申请企业帐号。',
  condition_personal_info: '完整填写企业及个人信息，并保证信息真实有效。',

  // d
  deploy_App: '部署应用',
  deploy_App_suc: '部署应用成功！',
  developer: '开发: ',

  // e
  edit_catalog: '编辑目录',
  edit_project: '编辑项目',
  empty_description: '没有数据',
  external_host: '外部主机',
  edit_by_form: '编辑表单',
  edit_by_yaml: '编辑 YAML',
  // events: "事件",
  events_content: '用户可以看到相关操作记录',
  eam_mechanism: '企业帐号管理机制',
  eam_mechanism_launch: '企业帐号管理机制重磅推出',
  eam_des: '企业帐号管理机制，系统性的支持云服务代销，极大的协助研华WISE-PaaS的分销伙伴以及系统集成商管理终端用户，以建立完整的平台生态系。',
  'eam agreement': '企业帐号管理协议',
  eam_conditions: '企业帐号申请条件',
  eam_account_pwd:
    '您的企业帐号开通成功后，您应妥善保管您的账号和密码，并正确、安全地使用。账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，您应自行负责，云平台并不承担责任。',
  eam_administrator:
    '您应将管理子订阅号的网络及云平台上各类应用和服务的人员实名开通为子订阅号管理员，如以上人员发生变动，您应自行将变动后的信息在线进行更新。因您提供的人员信息不真实、不准确、不完整，以及因以上人员的行为或不作为，或您未及时在线更新人员变动而产生的任何后果，均由您自行承担。',
  eam_deploy: '云平台专属空间之上部署的应用由个人自行负责。此外，自行升级应用可能会造成当机等不良影响，个人应自行承担风险并谨慎操作负责。',
  eam_follow_agreement:
    '您理解并同意，您及您的终端用户需遵循本协议《WISE-PaaS 工业物联网云平台服务协议》，因未能遵守必要设定、使用支持平台、遵循可接受的使用原则，或对服务的使用方式不符合服务之特性和功能(例如，试图执行不支持的作业)，或不符合云平台公布之指导方针等所产生的损害赔偿，云平台均不负责，您应自行承担所有一切协议下既有及衍生之义务及责任。',
  eam_platform_doc:
    '云平台提供的相关服务的功能以{website}公布的用户指南为准，亦可参考云平台技术白皮书《WISE-PaaS 工业物联网云平台架构与服务》。云平台有权适时更新服务的功能及相关文档，请登录{website}查阅相关文档的最新版本。',
  eam_answered: '申请将在3个工作日内递交并得到答复。',
  ea_apply: '企业帐号申请单',
  ea_VIP: '只有VIP及以上会员才能申请企业账户',

  // f
  feature_setting: 'Feature Setting',
  free_trial_product: '云产品免费试用',
  free_trial_desc: '免费体验超快速，多场景，易于操作和维护的IoT云产品。',

  // g
  group_theme_name: '群组',
  group_theme_subname: '群组是一个组织您的项目、资源管理访问权限以及在您团队内部共享资源等的逻辑单元，可以作为您团队工作的独立工作空间',
  group_list: '群组列表',
  group_owner: 'Group 权限',
  go_now: '现在前往',

  // h
  histories: '历史',

  // i
  IApp_title: 'I.App',
  IApp_s_p: 'I.App 入门包',
  IApp_subtitle: '用户可以看到有权限的应用，并快速部署应用',
  internal_host: '内部主机',
  invite_member: '邀请成员',
  info: '详情',

  // j

  // k
  key_management: 'Key 管理',

  // l
  // last: "上次登陆时间：",
  last_login_time: '上次登陆时间',
  last_update_time: '上次更新时间',
  limit: '限制',
  load: '加载中',
  load_fail: '加载失败',
  loading_app: '加载 App 列表...',
  loading_catalog: '加载目录列表...',
  loading_group: '加载群组列表...',
  loading_plugin: '加载插件列表...',
  loading_project: '加载项目列表...',
  loading_records: '加载订阅记录...',
  logging: '日志',
  login_success: '登入成功',
  login: '登录',
  learn_more: '了解更多',

  // m
  managed: '管理',
  marketplace: '市场',
  marketplace_setting: '市场设置',
  marketplace_setting_content: 'admin账户可以设置marketpalce catalog, 整个系统的用户均可以部署',
  member_theme_name: '成员管理',
  member_theme_subname: '列举出该Group的Group Owner',
  more: '更多',
  my: '我的',
  my_content: '用户可以看到已经订阅过的Catalog',
  my_subscription: '我的订阅',
  my_subscriptions: '我的订阅',
  m_s_r: '按月订阅需付',

  // n
  // notification: '通知',
  // no_data: "无数据",
  notification_theme_name: '公告',
  notification_theme_subname: '可查看最新全部公告信息',
  no_email: '抱歉，没有找到该邮箱的登录入口，请您自行登录邮箱查看密码。',
  no_show: '下次不再显示。',
  new_product: '新品发布',
  // o
  overview: '首页',
  official_website: '云平台官网',

  // p
  project: '项目',
  projects: '项目',
  project_theme_subname: '每个租户可以创建多个项目，分配给不同的成员管理',
  pipeline: 'Pipeline',
  pipeline_number: 'pipeline 数量',
  private: 'Private',
  private_groups: '私有群组',
  // products: '服务目录',
  project_number: '项目数量',
  // property: '属性',
  public_catalog: '公共目录',
  public_catalog_them_name: 'SRP Application',
  public_catalog_them_subname: '用户可以看到有权限的应用，并快速部署应用',
  position_tips: '根据您当前的位置，推荐您查看适用于您所在位置的内容。',
  purple: '紫色',
  purchase_options: '价格详情',
  // 'project_catalog_info_sub_title: 'Project catalog info subTitle',
  // 'project_catalog_info_title: 'Project catalog info title',
  product_release: '产品发布',
  project_owner: 'Project 权限',
  public_setting: '公共设置',
  pricing_details: '定价详情',
  public_setting_content: 'admin账户可以设置public catalog, 整个系统的用户均可以部署',

  // q
  quick_start: '快速开始',
  quick_use: '六步骤快速入门 WISE-PaaS/IoTSuite。',

  // r
  // remember_me: "记住我",
  records: '记录',
  // refresh: "更新",
  resume: '恢复',
  rollback: '回退',
  release_note: '发行说明',
  resale_services: 'WISE-PaaS/EnSaaS 企业帐号机制系统性的支持云服务代销。',

  // s
  // search: "搜 索",
  select_date: '选择日期',
  logOut: '登出',
  started: '已启用',
  subscribed: '订阅',
  redeem: '兑换',
  subscription_records: '订阅记录',
  subscription_records_content: '用户可以看到历史订阅记录',
  subTitle: 'subTitle',
  sure_to_delete: '确定删除？',
  system_setting: '系统设置',
  service_category: '服务类别',
  service_provider: '服务供应商',
  s_a_s_c: '服务架构和产业应用',
  service_details: '服务详情',
  CST: 'WISE-PaaS 云服务试用申请表',
  selectService: '请选择您要试用的服务',
  saleskit_desc: '一站式工业物联网应用开发套件和云原生平台。',

  // t
  tenant: '租户: ',
  theme: '主题',
  thirdparty_setting: '第三方设置',
  title: '标题',
  tip: '温馨提示',

  // u
  unstarted: '未启用',
  up: '起',
  update_app: '更新App',
  userCenter: '用户中心',
  update_app_suc: '更新App成功！',
  URL_Address: 'URL地址',
  // user: "用户",
  user_name: '用户名',

  // v
  // view: "查看",
  version_info: '版本信息',
  view_email: '查看邮箱',

  // w

  // x

  // y
  you_go_to_now: '您现在将前往: ',
  // z

  //试用申请页面
  Developer: '开发者',
  'IT operation and maintenance': 'IT运维',
  Student: '学生',
  'Business decision-maker': '商务决策者',
  'Technology decision-maker': '技术决策者',
  Architect: '架构师',
  Other: '其它',
  'Subscription Id': '订阅号',
  CRMID: 'CRMID',
  'User Info': '用户信息',
  Company: '公司',
  Email: '邮箱',
  'Contact Phone': '联系电话',
  Profession: '职业',
  'Trial Service': '试用服务',
  'Service Category': '服务类别',
  'Service Name': '服务名称',
  'Service Plan': '服务Plan',
  'Apply Questionnaire': '申请问卷',
  format_err: '格式不正确,请重试。',
  i_agree: '我已阅读并同意',
  agreement: '云服务试用协议',
  'First Name': '姓氏',
  'Last Name': '名字',
  'Member Type': '会员类型',
  // desc
  // mp_desc:
  //     "管理中心是 EnSaaS K8s Service 的控制台，EnSaaS K8s Service 基于 Kubernetes 为用户提供了开箱即用的微服务框架、企业级的容器管理平台、多层级的租户工作空间以及一致性的基础设施封装，为应用提供了全生命周期管理。",
  // sso_desc:
  //     "用户中心是 WISE-PaaS 为用户提供的一套安全，便捷，开放的统一身份认证服务，包括用户身份管理、企业帐号管理、客户端管理等功能，支持单点登录，以及灵活的应用整合方式。",
  // service_desc:
  //     "服务中心是 PostgreSQL、MongoDB、InfluxDB 等多元数据库、RabbitMQ 消息中间件、AIFS 等所有托管服务实例的控制台。服务中心提供了数据库访问以及设备接入平台的密钥创建、更新、删除等全生命周期管理功能以及便捷的操作界面。",
  // bill_desc:
  //     "计费中心即费用中心，用户可以实时查看订单状态、交易明细、服务价格与会员折扣，以及月账单等信息。",
  // ticket_desc:
  //     "工单中心为平台用户在线解决各种问题。所有订阅号用户均可以透过此系统创建问题工单，技术支持工程师将根据问题类别与情况逐一处理。",

  // =======================          Minisite Portal          =======================

  // 各模块关键词
  announcement: '产品公告',
  product_guides: '使用指南',
  product_brief: '产品简报',
  report_bug: '联系我们',
  faq: '常见问题',
  technology_blog: '技术白皮书',
  troubleshoot: '故障排查',
  admin_console: '管理控制台',
  product_title: 'EnSaaS Minisite',
  technical_documentation: '技术文档',
  market_resources: '营销资源',
  summit: '物联网峰会',
  resource_center: '资源中心',
  resource_center_desc: '在研华资源中心，您可获取到工业物联网新闻及最新技术信息',
  app_name_minisite: '产品名称',
  please_select_role: '请选择角色',
  select_product: '请选择',
  please_select_appname: '请选择产品名称',
  confirm_to_delete_role: '您确定要删除此角色吗？',
  add_role_warn: '该权限已存在，请勿重复添加！',
  add_admin_role_warn: '已添加最高权限，无须添加其它权限！',

  // MD
  no_language_version: '暂无此数据的{value}版本',
  view_detail: '查看详情',
  view_more: '查看更多',
  more_upper: '更多',
  immediately_view: '立即查看',
  free_trial: '免费试用',
  // total_items: "共 {value} 条",
  input_email: '请输入邮箱',
  textArea: '请输入详细说明',
  input_require_desc: '请输入需求概述',
  upload: '上传图片',
  upload_label: '单击或拖拽文件至此区域即可上传',
  upload_remark: '支持单次或批量上传(批量最多支持三个文件)',
  business_support: '商务支持',
  technical_support: '开发技术支持及培训与认证',
  cloud_service: '云服务故障报修、订阅与权限相关问题',
  email: '邮 箱',
  submit_success: '成功',
  submit_error: '失败',
  success_desc: '邮件发送成功!',
  error_desc: '邮件发送失败!',
  muti_error: '最多只允许上传三个文件！',
  app_detail: 'App 详情页',
  product_publish: '发布',
  please_input_search: '请输入关键字',

  // Contact us
  require_desc: '需求概述',
  bug_desc: '详细说明',
  submit_problem: '提交问题表单',
  service_need: '您可能需要的服务',
  download: '技术资料下载',
  know: '知道了',
  forward_login: 's 后自动跳转至登录页',

  // Guides
  year: '年前',
  month: '月前',
  day: '天前',
  hour: '小时前',
  minute: '分钟前',
  second: '秒前',

  // =======================           mp Portal           =======================

  // 'management': '管理中心',
  // 'console': '工作台',
  // 'lang': '语言',
  // 'catalog': '应用商店',
  '.and-should_not_be_at_the_beginning_or_end': '. 和 - 不能放在首位和末位',
  // a
  active: '启动',
  active_line: '在线',
  active_time: '创建时间',
  // add: '添加',
  // address: '地址',
  after_restart: '重启后',
  agent_status: '代理状态',
  //   all: '全部',
  // alternative_email: '备用邮箱',
  and_bath_assign: '以及配额导出',
  application: '应用',
  application_management: '应用管理',
  applications: '应用',
  applications_desc: '提供一个应用层级的视角，以应用级别查看部署状态与变化，同时可对应用进行升级、重新部署、启停与管理。',
  are_you_sure_to_map_the_key_to_quota: '确定将这/这些{key}映射至配额 ',
  'are_you_sure_to_unassign the quota_quotaName_in_namesapce_namespaceName': '确定要取消命名空间{namespaceName}绑定的配额{quotaName}？',
  are_yuo_sure_to_delete_follow_users_permission: '确定删除以下用户权限吗？',
  assign_quota: '绑定配额',
  assign_quota_msg: '{key}{keyName}已绑定配额{quotaInit}，确定重新绑定到配额{quotaNew}？',
  auto_scale: '是否弹性伸缩',
  auto_scale_desc:
    '是否启用工作空间的弹性伸缩功能。设置为false，表示为此工作空间绑定固定的工作空间配额；设置为true，表示为此工作空间启用弹性伸缩功能，该工作空间不再绑定在固定的工作空间配额，而是在最小配额和最大配额之间动态变化。',
  available_quotas: '有效配额',

  // b
  back_to_mp: '返回列表',
  // batch_assign: '批量映射',
  basic_information: '基本信息',
  batch_add: '批量添加',
  // batch_delete: '批量删除',
  before_restart: '重启前',
  broker_host: 'Broker地址',
  // 'billing': '费用',

  // c
  // 'cancel': '取消',
  clear: '清除',
  click_to_sort_by_ascending: '点击以由小到排序',
  click_to_sort_by_descending: '点击以由大到小排序',
  click_to_cancel_sorting: '点击取消排序',
  cluster_lower: '集群',
  // 'cluster': '集群',
  clusters: '集群',
  clusters_desc: '集群是计算、存储和网络资源的集合，Kubernetes 利用这些资源运行各种基于容器的应用',
  cluster_information: '集群信息',
  cluster_initialization: '初始化集群',
  cluster_status: '集群状态',
  cluster_agent: '集群/代理',
  close: '不再显示',
  close_switch: '关闭',
  // city: '城市',
  // company: '公司',
  compute_resource_quota: '计算资源配额',
  // 'config': '配置文件',
  config_host: '配置主机',
  config_map: 'ConfigMap',
  // confirm: '确认',
  // contact_phone: '联系电话',
  // 'contact_technical_support': '联系技术支持',
  count: '总数',
  // country_region: '国家/地区',
  // 'create': '创建',
  cpu_nodes: 'CPU节点',
  create_cluster_lower: '创建集群',
  create_workspace_lower: '创建工作空间',
  create_namespace_lower: '创建命名空间',
  create_workspacequota_lower: '创建工作空间配额',
  create_namespacequota_lower: '创建命名空间配额',
  // 'create_time': '创建时间',
  created_at: '创建时间',
  current_application: '当前应用',
  current_cluster: '当前集群',
  current_namespace: '当前命名空间',
  current_quota: '当前配额',
  current_workspace: '当前工作空间',

  // d
  // data_center: '数据中心',
  datacenter_code: '数据中心',
  dedicate_cluster: '专用集群',
  'defer_scale-in_for': '缩容触发时延',
  'defer_scale-in_for_desc': '工作空间满足缩容标准时，在配置的缩容触发时延达到后，工作空间开始缩容。单位：分钟。默认是10分钟。',
  // 'delete': '删除',
  // delete_role: '确定要删除此角色吗？',
  // delete_roles: '确定要删除这些角色吗？',
  // delete_user: '您确定要删除{name}吗？',
  // deleted: '已删除',
  deleting: '删除中',
  deployed: '已部署',
  delete_desc: '你确定要删除吗?',
  delete_quota_desc: '这个quota现在正在被使用，无法删除',
  delete_results_are_follows: '删除结果如下：',
  details: '详情',
  // disabled: '禁用',
  donot_unassign_auota: '{key}不能被取消绑定！',
  download_config_error: '下载 config 失败!',

  // e
  // 'edit': '编辑',
  edit_cluster_lower: '编辑集群',
  edit_workspace_lower: '编辑工作空间',
  edit_namespace_lower: '编辑命名空间',
  edit_desc: '你确定要编辑Yaml吗?',
  edit_yaml: '编辑Yaml',
  // 'empty': '空',
  // error: '失败',
  external_domain: '外部域名',
  // events: '事件',

  // f
  failed: '失败',
  // first_name: '名字',
  // forgot_pwd: "忘记密码",

  // g
  general_workspaces: '常规工作空间',
  gpu_nodes: 'GPU节点',
  guide_step1: '新增工具箱功能，快来体验吧！',

  // h
  // 'hi': '嗨',
  // highest_role: '最高权限',

  // i
  // industry: '行业',
  infrastructure: '基础设施',
  // ingress: 'Ingress',
  // invite: '邀请',
  ingress_desc: 'Ingress把来自集群外部的HTTP和HTTPS流量导入到集群内的某个APP',
  ingress_overview: 'Ingress 概览',
  initialization: '初始化',
  install_package: '安装helm包',
  internal_domain: '内部域名',
  invite_user_to_cluster_or_workspace: '用户已经存在，是否要邀请该用户加入您的集群或工作区？',

  // j

  // k

  // l
  last: '登录时间',
  // last_login: '上次登录时间',
  // last_name: '姓氏',
  // license_invalid: "License 已失效，服务已停用",
  // license_invalid_days_14: 'license 已失效，服务还能试用14天',
  // license_invalid_days_front: 'license 已失效，服务还能试用',
  // license_invalid_days_last: '天',
  // license_invalid_immediately: 'License 已失效, 服务即将不可用',
  // loading: '加载中',
  log: '日志',
  // log_out: '退出登录',

  // m
  max_quota: '最大配额',
  max_quota_desc: '弹性伸缩的最大工作空间配额，只能选择16个内置配额中的一个，且要大于最小配额。',
  min_quota: '最小配额',
  min_quota_desc: '弹性伸缩的最小工作空间配额，只能选择16个内置配额中的一个，且要小于最大配额',
  minutes: '分钟',
  monitor: '监控',
  mp_reactour_step1: '事件菜单新增Pod重启事件功能。',
  mp_reactour_step2: '监控功能里加入了Service Usage的监控。',
  mp_reactour_step3: 'Service Portal移到这里了。',

  // n
  // 'name': '名称',
  name_input: '名称',
  namespace_lower: '命名空间',
  // 'namespace': '命名空间',
  namespace_unbind: '命名空间(未绑定)',
  namespace_bind: '命名空间(已绑定)',
  namespaces: '命名空间',
  namespaces_desc: '命名空间是对一组资源和对象的抽象集合，提供隔离作用，常用来将系统内部的对象划分为不同的项目组或用户组',
  namespace_information: '命名空间信息',
  namespacequota_lower: '命名空间配额',
  namespacequota: '命名空间配额',
  namespaceQuota: '命名空间配额',
  namespacequotas: '命名空间配额',
  'namespace quotas': '命名空间配额',
  namespace_quotas: '命名空间配额',
  'namespace-quotas': '命名空间配额',
  namespace_quotas_desc: '命名空间配额是用来限制用户资源用量的一种机制。用于命名工作空间的资源用量',
  namespace_scale_desc: '资源配额用于限制用户命名空间的资源消耗',
  namespace_status: '命名空间状态',
  namespace_usage_t5: '命名空间 (用量前5名)',
  no_any_been_assigned: '没有任何映射',
  // 'no_data': '没有数据',
  node: '节点',
  nodes: '节点',
  nodes_desc: '节点是集群中的工作主机，是Pod真正运行的主机，可以是物理机，也可以是虚拟机',
  node_usage_t6: '节点（用量前6名）',
  // not_login: '尚未登录',
  // not_receive_email: "没有收到注册邮件吗？",
  notice_front:
    'KubeEnSaaS 已更新至 4.0.20 版。为进一步丰富用户的使用场景，这一版我们增加了对GPU资源的运维和管理。更多新特性请参考',
  notice_back: '。',
  no_cluster: '没有集群',
  no_workspace: '没有工作空间',
  no_plan: '没有方案',
  now_replicas: '当前的实例数',
  new_replicas: '新的实例数',

  // o
  object_count_quota: '其他配额',
  // 'ok': '确认',
  offline: '离线',
  // 'operation': '操作',
  // operator: '操作者',
  // 'order': '订单',
  operation_time: '操作时间',
  // operation_type: '操作类型',
  // operation_records: '操作记录',
  _overview: '概览',

  // p
  // password: '密码',
  paste: '粘贴',
  paste_msg: '您的浏览器只允许粘贴在终端中复制的文本。如果要从剪贴板粘贴，请按 Ctrl + Insert 键',
  // path: '路径',
  'pending-install': '等待安装',
  physical_resource_usage: '物理资源用量',
  // p_i_pwd: "请输入密码",
  // 'please_input_ ': '请输入',
  please_input_username: '请输入用户名',
  please_input_keywords: '请输入关键字',
  please_input_description: '请输入描述',
  pvc_disk: '持久化存储卷',
  'platform-management': '平台管理',
  pod: 'Pod',
  pod_restart_alarm: 'Pod 重启事件',
  pod_restart_alarm_desc: '当pod重启的时候，会产生一条pod重启事件，同时记录该pod重启前后的日志。同一个pod重启多次，仅仅记录最近一次的重启日志。',
  processing: '进行中',
  // p_s_rc: '请选择国家或地区',

  // q
  // 'quota': '配额',
  quotas: '配额',

  // r
  ready_total: 'Ready/Total',
  // refresh: '刷新',
  // 'remember_me': '记住我',
  resource_information: '资源信息',
  // resources_mgmt: '资源管理',
  resource_overview: '资源概览',
  resource_service: '服务管理',
  resource_permissions: '资源权限',
  resources_permission_mgmt: '资源权限管理',
  restart_time: '重启时间',
  // resources_permission_exist: '资源权限已存在',
  // resource_permissions_sub: ' 新建，分配，管理用户的资源权限和角色',
  request_limit: '请求/限制',
  // 'role': '角色',
  rootfs: '磁盘',
  router_management: '路由管理',
  // 'rules': '规则',

  // s
  // save: '保存',
  scale: '扩/减容',
  // search: '搜索',
  // secret: '密钥',
  // 'service': '服务',
  // services: '服务',
  service_name_in_secret: '密钥中的服务名称',
  shared_cluster: '共享集群',
  // 'sign_in': '登录',
  sign_in_to_developer_network: '登录到开发人员网络',
  // sign_in_sub: "登入到开发者网络",
  // skip: '跳过',
  sorry_no_app_permission: '您尚未订阅服务',
  sorry_no_resource_permission: '抱歉，您没有资源权限！',
  sorry_no_subscription_permission: '抱歉，您没有订阅号权限！',
  start_switch: '开启',
  // 'status': '状态',
  stopped: '停止',
  storage_resource_quota: '存储资源配额',
  // 'subscription_name': '订阅号名称',
  // success_save: '保存成功',
  // 'support_message': '如果您遇到问题需要技术支持，请发送电子邮件至',
  suspended: '已暂停',
  svc: '服务名称',
  system_settings: '系统设置',

  // t
  target_name: '目标名称',
  // themes: '主题',
  terminal: '终端',
  terminal_desc: 'Kubectl 命令行接口',
  // 'tickets': '工单',
  the_name_has_been_taken: '该名字已被使用',
  // 'this_field_is_required': '. 和 - 不能放在首位和末位',
  total_service: '总数',
  toolbox: '工具箱',
  toolbox_desc: '工具箱提供了config获取和Web Kubectl操作工具',
  // 'total_items': '共 {value} 条',
  // 'type': '类型',

  // u
  unassign_quota: '取消绑定配额',
  unbind: '取消绑定',
  // 'units': '单位',
  // update_time: '更新时间',
  usage_quota: '用量/配额',
  // 'user': '用户',
  users: '用户',
  // user_base_info: '用户基本信息',
  // 'user_center': '用户中心',
  user_groups: '用户组',
  // user_info: '用戶信息',
  // user_info_sub: '用户的基本信息和权限',
  // username: '用户名',
  // username_email: '用户名（邮箱）',

  // v
  // 'view': '查看',
  Version: '版本',
  view_yaml: '查看yaml',
  view_in_yaml: '查看yaml',
  view_these_binded_key_and_export_them_quotas: '查看{key}配额使用情况、批量绑定配额{quotas}',

  // w
  //   'web_kubectl': 'Web Kubectl',
  what_new: '新功能',
  workloads_app_desc: '属于应用的工作负载',
  workloads_desc: '用户在命名空间中部署的应用',
  workspace_lower: '工作空间',
  // 'workspace': '工作空间',
  workspace_unbind: '工作空间(未绑定)',
  workspace_bind: '工作空间(已绑定)',
  workspace_create_tip: '只接受a-z 0-9且最多16个字符',
  workspace_create_tip_else: '只接受 a-z 0-9 . - 字符',
  workspace_name: '工作空间名称',
  workspaces: '工作空间',
  workspaces_desc: '工作空间是一个管理命名空间、资源管理访问权限以及在内部共享资源等的逻辑单元，可以作为独立工作空间使用',
  workspace_information: '工作空间信息',
  workspace_status: '工作空间状态',
  workspacequotas: '工作空间配额',
  workspacequota_lower: '工作空间配额',
  workspacequota: '工作空间配额',
  workspaceQuota: '工作空间配额',
  'workspace quotas': '工作空间配额',
  workspace_quotas: '工作空间配额',
  'workspace-quotas': '工作空间配额',
  workspace_quotas_desc: '工作空间配额是用来限制用户资源用量的一种机制。用于管理工作空间的资源用量',
  workspace_scale_desc: '资源配额用于限制用户工作空间的资源消耗',
  workspace_usage_t5: '工作空间（用量前5名）',
  '--without_quota--': '--不指定配额--',

  // =======================           MP Lite Portal           =======================
  access_url: 'Access URL',
  application_name: '实例名称',
  Application: '应用',
  app_name: '应用名称',
  can_not_update: '没有可升级的版本',
  classification: '分类',
  gpu: 'GPU',
  package_name: '服务包名',
  redeploy: '重新部署',
  restart: '重启',
  service_package: '服务包名称',
  start: '启动',
  start_app: '启动',
  stop_app: '停止',
  sure_restart: '确定要重启此应用吗？',
  sure_redeploy: '确定要重新部署此应用吗？',
  sure_start: '确定要启动此应用吗？',
  sure_stop: '确定要停用此应用吗？',
  sure_update: '确定要升级此应用吗？',
  unclassified: '未分组',
  update_to_version: '更新至{version}',
  workspace_id: '工作空间ID',
  verify_sub: '为了您的安全，我们需要验证您的身份。 我们已经向电子邮件发送了验证码。',
  // Service Portal
  advanced_parameters: '其他参数',
  aggregate: '总量',
  all_subscription: '全部订阅号',
  array: '数组',
  authentication_database: '认证用数据库',
  auto_input: '自动生成',
  back_to: '返回至',
  bindable: '可绑定',
  bind_model: '绑定模式',
  body: '身体',
  boolean: '布尔值',
  broker_bindable: '可绑定',
  broker_display_name_tooltip: '显示在密钥中的服务名称。',
  broker_plan_id: '方案ID',
  broker_service_id: '服务ID',
  broker_url: 'Broker网址',
  canceling: '正在取消...',
  cancel_subscribe: '取消订阅',
  cancel_success: '取消成功！',
  capacity: '容量',
  charge_type: '收费类型',
  select_storage_class: '选择存储类',
  cluster_not_found: '集群不存在。',
  cluster_type: '集群类型',
  create_broker_title: '新增服务',
  credentials: '证书',
  create_DCCS: '创建服务密钥',
  create_pvc_radio1: '使用存储类动态创建',
  create_secret: '创建密钥',
  create_secret_title: '密钥管理',
  create_secret_subscription: '管理连线至服务需要的密钥',
  create_success_sp: '创建成功！',
  creating: '正在创建...',
  creation_time_mp: '创建时间',
  dashboard_url: '仪表面板网址',
  database_version: '数据库版本',
  dataService: '料号信息',
  db_help_message: '只允许使用a-z、A-Z、0-9、-，-不得在开头，且上限为63个字符。',
  db_help_tooltip: '{name}只允许使用a-z、A-Z、0-9、-，-不得在开头，且上限为63个字符。若不填写，则绑定时会自动生成一组{name}。',
  db_name: '数据库名称',
  dccs_key: '服务密钥',
  dccs_name: '服务密钥名称',
  delete_cluster: '删除集群',
  delete_instance_a: '确定要删除实例吗？此操作不会影响数据库。',
  delete_instance_b: '执行此操作会将此实例所使用的数据库删除，您确定吗？',
  delete_instance_c: '确定要删除实例吗？',
  delete_service_broker: '具有相同服务名称和方案的项目将会被一并删除。确定要删除吗？',
  delete_success: '删除成功！',
  delete_secret: '刪除 {secretName} 后将无法恢复。确定要删除吗？',
  deployment_properties: '部署属性',
  deployment_name: '部署名称',
  detached: '已分离',
  detach_cluster: '分离集群',
  detachedClusters: '分离集群数',
  detachedInstances: '分离实例数',
  disable_success: '停用成功！',
  disable_mp: '停用',
  disabling: '正在停用...',
  edit_DCCS: '编辑',
  edit_instance: '编辑实例',
  update_secret: '更新密钥',
  please_input_name: '请输入{type}名称',
  edit_instance_checkout_msg: '重启密钥所在的命名空间下的所有应用',
  edit_success: '编辑成功！',
  enable_success: '启用成功！',
  enabling: '正在启用...',
  enter_any_value: '此项在私有云环境可以输入任意值。',
  external_hosts: '外部地址',
  existing_storage_class: '已有存储类',
  form: '表单',
  header: '头部',
  host_role: '此字段的格式为{tag1}host{tag2}:{tag1}port{tag2}，若有多组，每组请以逗号(,)分隔',
  input_regexp_1: '仅允许 [a-zA-Z0-9.-]',
  input_regexp_2: '. 和 - 不允许出现在开头与结尾',
  input_regexp_3: '仅允许数字',
  input_regexp_4: '仅允许 [0-9a-f-]',
  input_regexp_5: '仅允许 [a-zA-Z0-9:-.,]',
  input_regexp_6: '仅允许 [a-z0-9.-]',
  input_regexp_7: '仅允许 [a-zA-Z0-9._-] 和空格',
  input_regexp_8: '仅允许 [a-zA-Z0-9._-]',
  input_regexp_9: '不允许空格',
  input_regexp_10: '仅允许 [a-zA-Z0-9_-.+]',
  input_regexp_11: '仅允许 [a-zA-Z0-9_-./@:]',
  input_regexp_12: '此名称为保留名称，请使用其他名称。',
  input_regexp_13: '不合法的名称，请使用其他名称。',
  input_regexp_14: '仅允许 [a-zA-Z0-9.-]且必须以小写字母开头。',
  instance_id: '服务实例 ID ',
  instance_name: '实例名称',
  instance_list: '实例列表',
  instancesQuota: '实例配额',
  integer: '整数',
  internal_hosts: '内部地址',
  key: '键',
  key_repeat: '{keyZH}不可重复。',
  loading_app_list: '正在加载APP列表...',
  location: '位置',
  max_length: '输入文本长度不能超过{length}个字符。',
  name_repeat: '已存在相同名称的{name}。',
  namespace_not_found: '命名空间不存在。',
  monitoring: 'Monitoring',
  next_page: '下一页',
  no_instance: '查无实例',
  no_pn: '查无料号',
  no_cluster_found: '找不到可用的集群。',
  no_namespace_found: '找不到可用的命名空间。',
  no_storage_class: '暂无存储类，使用存储类动态创建pvc，您需要至少有一个存储类。',
  no_workspace_found: '找不到可用的工作空间。',
  not_a_valid_UUID: '不是合法的UUID。',
  notice_front_lite:
    'EnSaaS K8s Service Lite 已更新至 4.1.5 版。该版本更新了页面样式，同时将订阅号选择框下移到每个页面中，拆分出EnSaaS-K8s-Service Lite，并合并了Service Portal，用于IoTSuite Edge的场景。更多新特性请参考 ',
  overview_create_dedicated: '建立专用集群',
  overview_create_shared: '建立共享集群',
  // parameters: '参数',
  persistent_disk_size: '永久磁盘大小',
  persistent_disk_type: '永久磁盘类型',
  persistent_volume: '存储',
  please_choose: '请选择',
  please_input_mp: '请输入',
  please_input_value: '请输入{value}。',
  plan_sp: '方案',
  plan_name: '方案名称',
  prev_page: '上一页',
  provider: '提供者',
  pseudo_id: '虚拟ID',
  pv: '持久卷',
  pv_desc: '持久卷 (PV) 是对底层共享存储的一种抽象，将共享存储定义为一种资源，它属于集群级别资源，不属于任何命名空间 。',
  pvc: '持久卷声明',
  pvc_desc: '持久卷声明 (PVC) 是用户对存储的请求。 它类似于pod。Pod消耗节点资源，持久卷声明会消耗存储资源。',
  recreate: '重建',
  recreating: '正在重建...',
  recreate_secret: '此操作将会在指定的命名空间中建立名为 {secretName} 的密钥 (Secret)，若命名空间中已经存在同名的密钥，将会被覆盖。',
  recreate_success: '重建成功！',
  recycle_strategy: '回收策略',
  redeploy_failed: '重新部署失败！',
  redeploy_success: '重新部署成功！',
  remainInstances: '剩余实例数',
  remain: '剩余数',
  rename: '修改名称',
  rename_instance: '修改名称',
  rename_instance_overview: '修改名称',
  rename_success: '修改成功！',
  resource_management: '资源管理',
  restart_all_apps_edit: '编辑完成后重启相有关联的应用',
  resume_cluster: 'Resume Cluster',
  running: '运行中',
  runningClusters: '运行集群数',
  runningInstances: '运行实例数',
  search_placeholder: '输入后请按ENTER键搜索{name}',
  secrets: '密钥',
  secret_name: '密钥名称',
  secret_management: '密钥管理',
  series: 'Series',
  service_instance: '服务实例',
  service_instance_list: '服务实例列表',
  service_instance_name: '服务实例名称',
  service_instance_id_tooltip: '产生一组service instance ID。',
  service_key: '服务密钥',
  service_list: '服务列表',
  service_list_subscription: '用户可以管理订阅中的服务',
  service_list_title: '实例列表',
  service_management_subscription: '管理员可以对服务进行管理',
  service_management_title: '服务管理',
  service_plan_name: '服务方案名称',
  service_usage: '服务用量',
  'service-usage-service-tooltip':
    'MongoDB、PostgreSQL仅支持Shared方案实例的用量监控，RabbitMQ仅支持standard方案实例的用量监控，EnSaaS-K8s-Service目前仅支持Dedicated Cluster方案实例的用量监控。',
  service_username: '用户名',
  ssl: 'SSL',
  scale_success: 'Scale successful!',
  scale_failed: 'Scale failed!',
  start_success: '启用成功！',
  start_failed: '启用失败！',
  stop_failed: '停用失败！',
  stop_success: '停用成功！',
  storage: '存储类',
  storage_class_desc: '存储类为管理员提供了一种描述存储的“类”的方法。 主要用于动态分配持久卷。',
  storage_statement: '存储声明',
  storage_volume: '关联的存储卷',
  string: '字符串',
  subscription_success: '订阅成功！',
  subscription_title: '建立实例',
  support: '支持',
  support_content: '如果您遇到技术支持问题，请发送电子邮件至 ',
  support_title: '联系技术支持',
  sure_to_cancel: '确定要取消订阅吗？',
  sure_to_disable: '确定要停用吗？',
  sure_to_enable: '确定要启用吗？',
  sure_to_recreate: '确定要重建吗？',
  this_is_required: '此项为必填项',
  time_since_create: '已创建时长',
  totalActive: '已启用集群',
  totalClusters: '集群总数',
  totalInactive: '未启用集群',
  totalInprogress: '待处理集群',
  total_mp: '总数',
  transaction_id: '交易ID',
  unlimited: '无限制',
  update_failed: '更新失败！',
  update_success: '更新成功！',
  update_broker_title: '更新服务',
  'user-defined-plan': '用户自定义方案',
  userId: '用户ID',
  // value: '值',
  vhost_name: 'vhost名称',
  view_resource: '查看资源',
  visit_model: '访问模式',
  vmSize: '虚拟机大小',
  vmType: '虚拟机类型',
  workspace_not_found: '工作空间不存在。',
  ':': '：',

  // =======================           sso           =======================
  // a
  account_owners: '帐户所有者',
  accounts: '成员',
  active_sso: 'Active',
  active_zh: '激活',
  add_enterprise: '添加企业帐号',
  add_enterprise_user: '添加企业帐号管理员',
  add_to_sub: '添加至订阅号',
  add_sub: '添加订阅号',
  add_sub_user: '添加订阅号用户',
  adjustment: '调整',
  admin_sso: '管理员',
  all_sub: '所有订阅号',
  all_enterprise: '所有企业帐号',
  all_normal_sub: '所有正式订阅号',
  app_id: 'App ID',
  app_role: '应用角色',
  app_permissions: '应用权限',
  available_points: '可用点数',
  available_credit: '可用额度',
  // b
  balance: '余额',
  billing_sso: 'Billing',
  bind_phone: '绑定手机',
  bind_phone_title: '绑定手机',
  bind_phone_info: '此功能目前仅在中国大陆地区试运行',

  // c
  change_pwd_by_policy: '请按照规则修改密码',
  client_sso: '客户端',
  clients_sso: '客户端',
  client_edit: '编辑客户端信息',
  client_id: '客户端 ID',
  client_name: '客户端名称',
  client_role: '客户端权限',
  client_sub: '注意：页面操作取决于您在组织中的权限。',
  client_s: '客户端创建成功！',
  client_s_sub: '请妥善保存您的客户端ID和秘钥。',
  client_s_notice: '您将只能在这里看到此密钥一次！所以一定要立即复制保存。',
  client_normal: '平台部署应用客户端',
  client_oauth: 'OAuth客户端',
  client_trust: '托管服务客户端',
  client_user: '应用用户',
  client_user_info: '管理客户端下的用户',
  close_sso: '关闭',
  clusterAdmin: '集群管理员',
  clusterOwner: '集群所有者',
  common_app: 'Common App',
  complete: '完成',
  cost_center: '支付中心',
  creation: '创建',
  creation_time_sso: '创建时间',
  create_client: '创建客户端',
  create_client_sub: '请输入客户端信息',
  create_retry_sso: '创建SSO帐号失败，请重试！',
  create_success_sso: '创建SSO帐号成功，您将收到一封EnSaaS SSO 帐号注册信,请您按照注册信中的信息及时修改密码。',
  creator: '创建者',
  crmid: 'CRM ID',
  current_hosting_status: '当前托管状态',
  // d
  datacenterAdmin: '数据中心管理员',
  delete_subscription: '确定要删除{name}吗？',
  delete_sub_role: '确定删除订阅号{name}的权限吗?',
  delete_with_name: '确定要删除{name}吗？',
  discount_record: '折扣率变更记录',
  document_sso: '文档',
  document_api: 'API文档',
  // e
  email_s: '邮箱',
  ensaas: 'EnSaaS',
  enterprise_account: '企业帐号',
  enterprise_account_sub: '企业帐号管理员可以建立企业帐号下的订阅号并管理订阅号下的用户',
  enterprise_export: '企业帐号导出',
  enterprise_user: '企业帐号用户',
  enterprise_user_sub: '设置企业帐号管理员',
  enterpriseAdmin: '企业帐号管理员',
  enter_member: '订阅号个数',
  expenses_record: '可用额度变更记录',
  // f
  // g
  globalAdmin: '平台管理员',
  go_creation: '返回创建页面',
  go_mgmt: '返回管理页面',
  go_to_change_pwd_sso: '修改密码',
  // h

  hosting: '托管',
  hosting_deal_subscription:
    '您收到来自订阅号管理员的 {count} 条托管处理请求，点击 OK 前往订阅号页面处理。或稍后自行前往【订阅号管理】【操作】【托管】进行处理。',
  hosting_deal_enterprise:
    '您收到来自企业帐号管理员的 {count} 条托管处理请求，点击 OK 前往订阅号页面处理。或稍后自行前往【订阅号管理】【操作】【托管】进行处理。',
  hosting_deal_both:
    '您收到来自订阅号管理员的 {subCount} 条托管处理请求和来自企业帐号管理员的 {epCount} 条托管处理请求，点击 OK 前往订阅号页面处理。或稍后自行前往【订阅号管理】【操作】【托管】进行处理。',
  hosting_state: '托管状态',
  hosting_record: '托管记录',
  // i

  identity_record: '身份变更记录',
  identity_before: '操作前身份',
  identity_after: '操作后身份',
  info_safe: '我们不会泄露您的手机信息',
  invite_user_sso: '用户已经存在，是否要邀请该用户加入您的集群或工作区？',
  is_paid_account: 'Is Paid',
  is_internal: 'Is Internal',
  // j
  // k
  // l
  last_modify_time: '上次修改时间',
  // m
  mgmt: '管理',
  management_user: '管理用户',
  management_user_info: '管理所有用户，包括添加、删除、启用和禁用等',
  member_type: '客户类型',
  m_detail: '明细',
  modify: '修改',
  modify_phone: '修改手机',
  my_profile: '个人资料',
  // n
  name_crmid: '名称（CRM ID）',
  namespaceDeveloper: '命名空间开发者',
  new_pwd: '新密码',
  new_pwd_confirm: '确认新密码',
  no: '否',
  not_remain_again: '不再提示',
  // o
  operating_time: '操作时间',
  operating_points: '操作点数',
  // operation_record: '操作记录',
  operation_record_sub: '记录关键的删除、新增、修改等操作',
  // operation_type: '操作类型',
  operation_total_points_before: '操作前总点数',
  ope_target_type: '目标类型',
  ope_target_name: '目标名称',
  ope_target_identity: '目标身份',
  ope_action: '操作',
  ope_operator_name: '操作者',
  ope_create_time: '操作时间',
  ope_target_id: '目标ID',
  ope_description: '描述',
  // p
  permission: '权限',
  p_i_app_id: '请输入APP ID',
  p_i_service_name: '请输入服务名',
  p_i_user_id: '请输入用户ID',
  p_i_integer: '请输入整数',
  p_i_city: '请输入您的城市',
  p_i_client_name: '请输入您的客户端',
  p_i_crmid: '请输入CRM ID',
  p_i_company: '请输入公司名称',
  p_i_sub_company: '请输入公司名称',
  p_i_scopes: '请输入权限集合,例如: admin,user',
  p_i_redirect: '请输入重定向路径',
  p_i_quota_point: '请输入可用额度',
  p_i_sub_name: '请输入订阅号',
  p_i_sub_short_name: '请输入订阅号名称',
  p_i_sub_rate: '请设置WISEPoint与所选货币的汇率',
  p_i_enterprise_name: '请输入企业帐号',
  p_i_sub_id: '请输入订阅号ID',
  p_i_trust_key: '请输入托管服务秘钥',
  p_i_valid_url: '请输入有效网址',
  p_i_verify_code: '请输入验证码',
  // p_i_phone: '请输入手机号码',
  p_s_dc: '请选择数据中心',
  p_s_cluster: '请选择集群',
  p_s_ws: '请选择工作空间',
  p_s_ns: '请选择命名空间',
  p_s_mt: '请选择帐户类型',
  p_s_sub: '请选择订阅号',
  p_s_enterprise: '请选择企业帐号',
  phone: '手机',
  phone_s: '手机',
  phone_number: '手机号码',
  points_spent: '已消费点数',
  points_credit: '信用点数',
  points_available: '剩余点数',
  points_available_trail: '剩余信用点数',
  points_total: '总点数',
  // q
  quota_point: '消费上限',
  // r
  record_OpenHosting: '委托托管',
  record_CloseHosting: '结束托管',
  record_OpenHostingRequest: '请求托管',
  record_CloseHostingRequest: '取消托管请求',
  record_ChangeHostingRequestPass: '请求托管被通过',
  record_ChangeHostingRequestReject: '请求托管被拒绝',
  redirect_url: '重定向路径',
  // remove: '移除',
  remove_user: '确定要把{name}从订阅号下移除吗？',
  remove_users: '确定要移除这些用户吗？',
  remove_email: '确定要移除{name}吗？',
  resources_permission: '资源权限',
  roles: '角色',
  roles_introduction: '角色介绍',
  roles_sub: '用户角色说明',
  role_ga: 'Global Admin',
  role_ga_des:
    'EnSaaS全球数据中心的管理者，负责全球所有数据中心的管理，有所有数据中心的最高管理权限；可以分配数据中心管理员、集群管理员及租户空间角色；有订阅号管理权限，可以创建订阅号和分配订阅号用户。',
  role_da: 'DataCenter Admin',
  role_da_des:
    '某个数据中心的管理者，负责本数据中心的管理，有本数据中心所有集群的最高管理权限；可以管理所有集群的资源，可以分配集群管理员及租户空间角色；有订阅号管理权限，可以创建订阅号和分配订阅号用户。',
  role_ca: 'Cluster Admin',
  role_ca_des:
    '某个Kubernetes集群的管理者，负责本集群的管理；有本集群的所有权限，包括所有工作空间和所有命名空间的管理权限，以及集群中所有部署的应用的管理权限，拥有本集群全部Kubernetes资源的管理权限；可以分配租户空间角色；没有订阅号管理权限。',
  role_co: 'Cluster Owner',
  role_co_des:
    '某个独享规格集群的所有者，负责本集群级别租户空间的管理；有本集群的访问权限，包括所有工作空间和所有命名空间的管理权限，以及租户在此集群中所部署的应用的管理权限，拥有本集群中部分Kubernetes资源的管理权限；可以分配工作空间和命名空间角色。没有本集群的订阅、升级、降级和退订等商务功能的操作权限。',
  role_wo: 'Workspace Owner',
  role_wo_des:
    '某个通用规格工作空间的所有者或某个独享规格集群中建立的某个工作空间的所有者，负责本工作空间级别租户空间的管理，有本工作空间的访问权限，有本工作空间下的所有命名空间的管理权限，以及租户在此工作空间中所部署的应用的管理权限，拥有本工作空间中部分Kubernetes资源的管理和访问权限；可以分配命名空间角色。没有本工作空间的订阅、升级、降级和退订等商务功能的操作权限。',
  role_nd: 'Namespace Developer',
  role_nd_des: '某个命名空间的开发者，有本命名空间的访问权限，包括本命名空间中所部署的应用的管理，拥有本命名空间中部分Kubernetes资源的管理权限。',
  role_s_sa: 'Subscription Admin',
  role_s_sa_sub:
    '某个订阅号的管理者，EnSaaS  订阅号与MyAdvantech企业帐号相对应。订阅号管理员有在EnSaaS云平台上订阅、升级、降级、退订产品/服务/资源(统称为云服务)的权限，订阅后默认拥有云服务的管理权限和访问权限；订阅号管理员有管理云服务订单、账单等商务功能的权限。',
  role_s_su: 'Subscription User',
  role_s_su_sub: '某个订阅号下的一般用户，拥有订阅号所订阅的云服务的管理和访问权限，没有服务订阅、退订权限，没有订单、账单等商务功能的管理权限。',
  role_srp_u: 'SrpUser',
  role_srp_u_sub: '某个应用类云服务的用户，有应用的访问权限，应用访问者具体所拥有的应用角色由应用最高权限访问者分配；SRPUser 没有EnSaaS 租户空间的访问权限。',
  role_not_insert_sso: '发现您有订阅号权限信息未添加至订阅还权限列表，需要返回修改吗？',
  // s
  scopes: '权限集合',
  security_code: '客户端密钥',
  send_pwd_phone_success: '成功发送密码重置短信。 页面将在5秒钟后跳转。',
  send_verify_code_again: '{name}秒后重新发送',
  send_pwd_email_sub_sso: '如果您忘记了密码，可以使用此工具重置密码。 提交后，您将收到一封包含链接的电子邮件或手机验证码，以完成该过程。',
  select_sub: '请选择订阅号',
  signOut: '登出',
  srp: 'Srp',
  srpUser: '应用用户',
  sso_permissions: 'SSO权限',
  success_delete: '删除成功',
  success_insert: '添加成功',
  subscription_details: '订阅号详情',
  subscription_export: '订阅号导出',
  subscription_mgmt: '订阅号管理',
  subscription_user: '订阅号用户',
  subscription_id_sso: '订阅号ID',
  subscription_detail: '管理订阅号下的用户',
  subscription_sub: '订阅号管理，信息查看',
  subscription_type: '订阅号类型',
  subscription_id_role: '订阅号角色',
  subscriptionAdmin: '订阅号管理员',
  subscriptionUser: '订阅号一般用户',
  subscribed_permissions: '订阅号权限',
  subscribed_permissions_up: '确定提升权限为订阅号管理员 ？',
  subscribed_permissions_down: '确定降低权限为订阅号一般用户 ？',
  sub_basic: '基本信息',
  sub_role: '权限配置',
  sub_rate_prompt1: '当前折扣率（{name} %off），直到本月底仍然有效。',
  sub_rate_prompt2: '新的折扣率将于下月生效。',
  sub_cost: '费用配置',
  sub_short_name: '订阅号名称',
  sub_company: '公司名称',
  sub_shared_discount: '共享会员折扣',
  sub_allow_billing: '允许访问费用中心',
  sub_service_trust: '请求服务托管',
  sub_service_trust_info: '若选择开启，订阅号管理员登录时会收到托管授权请求',
  sub_top_cost: '当前可用额度',
  sub_billing_unit: '费用账单单位',
  sub_billing_unit_info: '设置WISEPoint与所选货币的汇率后，订阅号的账单则按照这个汇率呈现',
  sub_discount_rate: '折扣率',
  sub_effective_discount: '生效折扣率',
  sub_exchange_rate: '汇率',
  sub_enter_admin: '企业帐号管理员',
  sub_guest_deal_request_choose_no: '不，我自己管理服务。',
  sub_guest_deal_request_choose_yes: '是的，管理员可以托管我的服务并访问我的数据。',
  sub_guest_deal_request_choose: '您希望向您的企业帐号管理员托管您的服务吗？',
  sub_guest_deal_request_label: '请求发起人',
  sub_guest_deal_request_for_label: '目标订阅号',
  sub_guest_deal_request_msg: '您的企业帐号管理员向您发送了一个服务托管请求，请在下面处理。',
  sub_guest_denied_msg: '订阅号管理员已终止您的托管权限',
  sub_guest_accept_msg: '您的服务托管请求已被接受',
  sub_guest_reject_msg: '您的服务托管请求已被拒绝',
  sub_guest_denied_label: '终结者',
  sub_guest_denied_form_label: '订阅号',
  sub_guest_hosting_label: '您的服务当前由企业管理员托管',
  sub_guest_unhosted_label: '您的服务未由企业管理员托管',
  sub_guest_configure: '配置托管状态',
  sub_guest_configure_no: '管理员不能托管我的服务和访问我的数据',
  sub_guest_configure_yes: '管理员可以托管我的服务并访问我的数据',
  sub_guest_prompt: '您可以从下面更改托管状态',
  sub_guest_request_label: '授权者',
  sub_guest_accept_label: '授权者',
  sub_guest_reject_label: '拒绝者',
  sub_guest_request_title: '您可以在下面更改托管设置',
  sub_guest_request_msg: '订阅号管理员已授予您托管权限',
  sub_hosting: '托管',
  sub_hosting_basic: '基本信息',
  sub_hosting_req_process: '请求处理',
  sub_hosting_status: '托管状态',
  sub_hosting_action: '托管动作',
  sub_hosting_unhost: '未托管',
  sub_hosting_hosted: '已托管',
  sub_hosting_hosting: '托管',
  sub_hosting_stop: '终止',
  sub_hosting_await_process: '待处理的请求',
  sub_hosting_none: '无',
  sub_hosting_process_sponsor: '请求发起人',
  sub_hosting_current_identity: '操作人身份',
  sub_hosting_request_initiator_identity: '请求发起人角色',
  sub_hosting_process_status: '请求状态',
  sub_hosting_pending_request: '待请求',
  sub_hosting_requesting: '请求中',
  sub_hosting_requested: '请求中',
  sub_hosting_denied: '拒绝',
  sub_hosting_request: '订阅号托管请求',
  sub_hosting_no_permission: '订阅号有待处理请求，您的身份暂无可处理动作。',
  sub_host_cancel_request_choose_no: '等待订阅号管理员回复',
  sub_host_cancel_request_choose_yes: '取消请求',
  sub_host_cancel_request_choose: '或者您可以取消请求',
  sub_host_cancel_request_label: '发送至',
  sub_host_cancel_request_msg: '已发送托管 子订阅号服务的请求，请等待回复',
  sub_host_request_title: '您可以请求子订阅号托管服务',
  sub_host_request_prompt: '您无权托管子订阅号的服务',
  sub_record: '订阅号记录',
  sub_record_point_consumption: '点数消费',
  sub_record_point_limit_change: '可用额度调整',
  sub_record_hosting_record: '托管请求',
  sub_action: '动作',
  sub_action_agree: '同意',
  sub_action_refuse: '驳回',
  sub_record_before_action: '操作前值',
  sub_record_after_action: '操作后值',
  sub_record_used: '已用',
  sub_record_remain: '剩余',
  sub_record_time: '时间',
  sub_record_approver: '审批人',
  sub_record_approver_identity: '审批人身份',
  sub_record_requester: '操作人',
  sub_record_requester_identity: '操作人身份',
  sub_record_quota_title: '可用额度变更记录',
  sub_record_quota_sub_title: '订阅号的可用额度变更记录和消费记录',
  sub_record_hosting_title: '托管记录',
  sub_record_hosting_sub_title: '订阅号的托管变更记录',
  sub_point_not_set: '无限制',
  support_info: '如果您遇到技术支持问题，请发送电子邮件至',
  system_sitting: '系统设置',
  // t
  tenant_space_role: '租户空间角色',
  trust_key: '托管服务秘钥',
  time_expire: '到期时间',
  time_inactive: '停用时间',
  time_freeze: '释放时间',
  time_formal: '转正时间',
  // u
  used_and_limit: '已使用/限额',
  user_exist_in_sub: '用户已在此订阅中存在',
  user_not_found: '用户不存在',
  user_u: '用户',
  user_l: '用户',
  user_manual: '用户手册',
  user_management_sub: ' 新建，分配，管理用户的订阅号权限和角色',
  unauthorized: '令牌已失效，请重新登入',
  unassigned: '未分配',
  unrestricted: '未限制',
  unconsumed: '未消费',
  // v
  verify_sub_sso: '为了您的安全，我们需要验证您的身份。 我们已经向{name}{change}发送了验证码。',
  verify_code_error: '验证码格式错误',
  verify_code_policy: '没有收到短信验证码？',
  verify_code_p_1: '1. 手机验证码存在延迟，可能需要2-3分钟才能收到，请稍后再试哦。',
  verify_code_p_2: '2. 如2-3分钟后，仍未收到，请检查您的手机是否已停止服务，或拦截了我们的短信，或短信收件箱已满。',
  verify_code_p_3: '3. 您可以尝试将SIM卡移动到另一部手机，然后重试，或者联系手机运营商咨询。',
  verify_code_p_4: '4. 当手机丢失、停用或不在身边时，建议您更换其他验证方式。',
  verify_identidy: '验证身份',
  vip_identity: '会员身份',
  // w
  workspaceOwner: '工作空间所有者',
  wise_point: '点数',
  // x
  // y
  yes: '是',
  // z

  // =======================          DB Backup & Restore          =======================
  backup: '备份',
  backup_name: '备份名称',
  backup_id: '备份ID',
  db_restore_id: '还原ID',
  input_restore_id: '还原ID',
  input_backup_id: '备份ID',
  backup_configuration: '备份配置',
  lowercase_backup_configuration: '备份配置',
  backup_management: '备份管理',
  restore_management: '还原管理',
  backup_schedule: '备份排程',
  lowercase_backup_schedule: '备份排程',
  backup_scheduler: '排程看板',
  start_time: '备份开始时间',
  end_time: '备份结束时间',
  backup_size: '备份大小',
  backup_type: '备份类型',
  full_backup: '全量备份',
  select_database_backup: '选择要备份的数据库',
  backup_type_full: '备份所有数据库',
  backup_type_individual: '备份单个数据库', // '指定需要备份的数据库列表'
  backup_type_individual_desc: '请选择数据库',
  all_status: '所有状态',
  all_services: '所有服务',
  no_instances: '无实例',
  done: '已完成',
  backing_up: '备份中',
  all_type: '所有类型',
  Full: '全量',
  individual: '单个',
  immediate_backup: '立即备份',
  backup_config_desc: '使用现有的备份配置',
  destination_storage: '选择作为备份目的地的存储',
  destination_storage_validate: '找不到任何存储，请先添加至少一个存储。',
  advanced: '高级',
  backup_period: '时间段',
  shard: 'Shard',
  retention: 'Retention Policy',
  shard_id: 'shard ID',
  retention_placeholder: 'retention policy名称',
  backup_duration: '备份持续时间',
  restore_duration: '还原持续时间',
  trigger_mode: '触发模式',
  selected_database: '备份数据库',
  storage_name: '存储名称',
  storage_type: '存储类型',
  advanced_information: '高级信息',
  view_log: '查看日志',
  save_settings: '将当前设置另存为新的备份配置',
  // batch_delete: '批次删除',
  batch_delete_msg: '您确定要删除这{item}条',
  data: '数据吗？',
  restore: '还原',
  stop_backup: '停止备份',
  stop_backup_msg: '您确定要停止备份吗？',
  restore_confirmation: '还原确认',
  restore_information: '还原信息',
  restore_policy: '还原策略',
  overwriting_database: '还原时覆盖现有的数据库',
  creating_database: '还原时创建新的数据库',
  restore_note: `#### 请注意：\n1. 在还原过程中不能执行其他备份或还原任务。\n2. 如果在还原过程中有排程任务要进行，则这些排程任务将被跳过。`,
  configuration_name: '配置名称',
  backup_destination_storage: '存储名称',
  restore_start_time: '还原开始时间',
  restore_end_time: '还原结束时间',
  schedule_name: '排程名称',
  frequency: '频率',
  start_backup: '确认开始备份',
  start_backup_with_configuration: '使用以下备份配置开始备份',
  start_according_settings: '备份将按照以下设置启动',
  edit_config: '编辑备份配置',
  delete_config: '删除备份配置',
  delete_remark: '以下排程正在使用这个备份配置：',
  delete_remark_s: '以下排程正在使用这个备份配置：',
  delete_warn: '删除备份配置前请先删除相依的排程。',
  confirm_delete_no_schedule: '您确定要删除该备份配置{name}吗？',
  restore_details: '还原详情',
  backup_details: '备份详情',
  stop_restore: '停止还原',
  stop_restore_msg: '您确定要停止还原{item}吗？',
  add_backup_schedule: '添加备份排程',
  backup_every: '备份每',
  start_at: '开始于',
  edit_backup_schedule: '编辑备份排程',
  cron_time: 'Cron 时间',
  enable_backup_schedule: '启用备份排程',
  disable_backup_schedule: '停用备份排程',
  enable_backup_schedule_msg: '您确定要{type}该备份排程{item}吗？',
  storage_settings: '存储配置',
  confirm_to_storage_settings: '确认离开本页，前往{type}页面？',
  add_storage: '添加存储配置',
  region: '域',
  access_key: '访问密钥',
  secret_key: '密钥',
  test_connection: '测试连接',
  // endpoint: '终端',
  signature_version: '签名版本',
  NFS_version: '版本',
  NFS_service: 'NFS 服务',
  remote_path: '远程路径',
  edit_storage: '编辑存储',
  edit_description_placeholder: '请输入描述',
  download_error: '下载失败',
  configuration: '配置',
  schedule: '排程',
  manual: '手动',
  storage_backup: '存储',

  connection_successful: '连接成功！',
  connection_failed: '连接失败！',
  add_config: '添加备份配置',
  instance: '实例(s)',
  cron: 'Cron 表达式：',
  no_log: '无日志数据',
  restore_warn_title: '有正在进行的{type}操作',
  restore_warn_content: '请稍后重试。',
  back_today: '今天',
  schedule_day: '日',
  source_database: '源数据库',
  new_database_name: '新数据库名称',
  all_database: '<所有数据库>',

  // Cron component
  week: '周',
  cron_month: '月',
  Mon: '周一',
  Tue: '周二',
  Wed: '周三',
  Thu: '周四',
  Fri: '周五',
  Sat: '周六',
  Sun: '周日',
  Jan: '一月',
  Feb: '二月',
  Mar: '三月',
  Apr: '四月',
  May: '五月',
  Jun: '六月',
  Jul: '七月',
  Aug: '八月',
  Sep: '九月',
  Oct: '十月',
  Nov: '十一月',
  Dec: '十二月',
  cron_start_time: '开始时间',
  cron_end_time: '结束时间',
  time_interval: '时间间隔',
  specify: '指定时间',
  timing_schedule: '定时调度',
  expiry_days: '到期日',
  expiry_time: '到期时间',
  custom_config: '自定义配置',
  schedule_warn: '删除此备份排程后，正在执行的备份可能会失败。',
  delete_schedule_msg: '您确定要删除该备份排程{name}吗？',
  time_warn: '开始时间必须早于结束时间。',
  backup_configuration_validate: '备份配置不能为空，请先添加备份配置。',
  instance_info: '实例信息',
  no_upcoming_schedule: '暂无排程',
  database_services: '数据库服务',
  instance_status: '实例状态',
  upcoming_schedule: '即将执行的排程',
  max_name_length: '最多可输入{length}个字符',
  backup_regexp_1: '仅允许 字母 数字 -  且必须以字母或数字开头',
  backup_regexp_2: '仅允许 字母 数字 . - 且必须以字母或数字开头和结尾',
  backup_regexp_3: '不允许空格',
  delete_backup_management: '删除备份',
  delete_restore_management: '删除还原',
  restore_job: '还原',
  delete_storage: '删除存储',
  delete_backup_restore_msg: '您确定要删除{type}吗？',
  is_deleted: '已删除',
  backup_disable: '停用',
  specify_destination: '指定还原目的地',
  all_databases: '<全部数据库>',
  test_connection_text: '测试连接',
  delete_backup_schedule: '删除备份排程',
  backup_info: '备份信息',
  schedule_info: '排程信息',
  source_all_warn: '被还原的实例必须是初始状态，若实例中已有数据库存在，请先移除。',
  protocol_title: '用户数据库备份还原服务协议签署',
  protocol_label: '请仔细阅读以下服务协议，同意后方可使用WISE-IoTSuite提供的数据库备份还原服务相关技术服务',
  backup_warn: '备份源数据库名称只允许使用 a-z、A-Z、0-9、-，-不得在开头，上限63字符',
  restore_error_warn: '数据库还原后需要手动创建Secret，App才可以进行连接',

  // =======================           KubeIot Portal           =======================

  device: '设备',
  latest_data: '最新数据',
  view_property: '查看属性',
  devices_devices_detail: '查看属性',
  summary: '总结',
  subdevice: '子设备',
  gateway: '网关设备',
  direct: '直连设备',
  tag: '标记',
  tags: '标记',
  device_shadow: '设备影子',
  command: '命令',
  device_link: '设备链接',
  devices_detail: '设备详细信息',
  devices: '所有设备',
  devices_desc: '设备描述',
  device_status: '设备状态',
  client_key: '客户端密钥',
  device_auth_type: '设备身份验证类型',
  product: '产品',
  group: '组',
  please_select_product: '请选择产品',
  please_select_device: '请选择设备',
  protocol_type: '协议类型',
  data_format: '数据格式',
  product_name: '产品名称',
  product_id: '产品ID',
  products_list: '产品',
  products_list_desc: '在物联网平台中，某一类具有相同能力或特征的设备的合集被称为一款产品。',
  device_type: '设备类型',
  smart_manufacturing: '智能制造',
  smart_industry: '智慧工业',
  smart_medicine: '智慧医疗',
  smart_retail: '智慧零售',
  smart_park: '智慧园区',
  others: '其它',
  manufacturer: '制造商',
  create_product: '创建产品',
  reset_secret: '重置密钥',
  device_name: '设备名称',
  device_id: '设备ID',
  gateway_id: '网关ID',
  device_twin: '孪生设备',
  item_tips: '{item}提示',
  command_tip:
    '如果设备所属产品定义了命令功能，则您可以通过应用调用平台接口或者操作下面的“命令下发”按钮下发命令。当前MQTT设备仅支持同步命令下发，NB设备仅支持异步命令下发。',
  synchronous_command_delivery: '同步命令传递',
  sync_deliver_command: '同步交付命令',
  asynchronous_command_delivery: '异步命令传递',
  async_deliver_command: '异步传递命令',
  queued_commands: '排队命令',
  historical_commands: '历史命令',
  device_secret: '设备密钥',
  // products: '服务目录'
  // update_time: '更新时间',
  // secret: '密钥',
  device_information: '设备信息',
  access_information: '接入信息',
  data_escalation: '数据上报',
  authentication_type: '身份验证类型',
  authentication_type_tip: `设备认证可确保与平台的安全连接和安全管理。
    使用密钥进行身份验证。
    使用 x.509 证书进行身份验证。`,
  add_sub_device: '添加子设备',
  certification_type: '认证类型',
  view_history_data: '查看历史数据',
  reset_secret_tip:
    '重置密钥后，原始密件将失效。新密钥必须在设备上更新，并且设备必须在平台连接期间携带新机密进行身份验证。您可以在下面的文本框中指定新的密钥。如果您没有指定新机密，则平台会自动生成一个。',
  new_secret: '新密钥',
  new_secret_tip: '如果您没有指定此参数，则平台会自动生成新的密钥。',
  confirm_new_secret: '确认新密钥',
  reset_name: '重置名称',
  no_command_parameters: '无命令参数。',
  duration: '时间',
  choose_command: '选择命令',
  delivery_policy: '交付政策',
  cache_duration: '缓存持续时间',
  bind_tags: '绑定标签',
  bind_tags_tip: '绑定标签，以便于查找特定设备。',
  tag_value: '标记值',
  add_tag: '添加标签',
  desired_value: '期望值',
  configure_property: '配置属性',
  sync_command: '交付命令',
  async_command: '交付命令',
  node_id: '节点 ID',
  // node_type: '节点类型',
  // value: '值',
  registered_devices: '注册设备数',
  product_detail: '产品详情',
  property_command: '模型定义',
  module_property: '属性',
  module_event: '事件',
  service_command: '命令',
  product_module: '模块',
  product_module_property: '属性',
  product_module_event: '事件',
  product_module_command: '命令',
  device_property_name: '属性名称',
  delete_module: '刪除模块',
  value_range: '取值范围',
  unit: '单位',
  length: '长度',
  size: '个数',
  item_type: '类型',
  device_command_name: '命令名称',
  device_command_params: '下发参数',
  device_command_responses: '响应参数',
  edit_module: '编辑模块',
  edit_property: '编辑属性',
  edit_command: '编辑命令',
  edit_event: '编辑事件',
  data_type: '数据类型',
  param_data_name: '下发参数名称',
  response_data_name: '响应参数名称',
  device_service_name: '模块名称',
  device_event_name: '事件名称',
  event_type: '事件类型',
  device_topo_map: '设备拓扑图',
  cloud: '云端',
  edge_clouds: '边缘云',
  topic_list: 'Topic列表',
  communication_topic: '通信Topic',
  other_communication_topic: '其他服务通信Topic',
  self_communication_topic: '自定义Topic',
  device_group: '设备群组',
  set_device_ext_info: '设置设备扩展信息',
  device_ext_info_tip: '您可以通过导入文件的方式快速设置扩展信息，平台支持Json格式转换为设备扩展信息内容。如需快速导入请按如下模板编写文件。',
  device_ext_info_module: '设备扩展信息模板',
  json_invalidate: 'Json格式错误',
  upload_device_ext: '上传设备扩展信息',
  device_detail: '设备详情',
  overviews: '概述',
  device_shadow_tip:
    '设备影子是一个Json文件，主要用于存储设备属性当前上报的属性值和IoT平台期望下发给设备的属性值，您可以通过命令、配置下发或者直接在设备影子中修改设备属性配置，如果因为设备异常或者离线导致无法配置下发成功，则可以待设备正常上线后同步生效。若设备上报的数据为二进制码流，则平台会对数据进行Base64加密，“上报值”显示加密后的数据。',
  reported_value: '上报值',
  desire_value: '期望值',
  command_type: '命令类型',
  send_time: '发送时间',
  finish_time: '完成时间',
  use_sub_info: '请使用以下信息进行设备连接和数据上报。',
  device_secert: '设备秘钥',
  sub_device_tip:
    '呈现通过网关方式接入到IoT的设备（传感器）。子设备的状态表示子设备接入网关的状态，由网关上报到IoT平台进行状态的刷新；如果网关不能正常上报子设备的状态信息到IoT平台，则展示的子设备状态不会刷新。',
  group_id: '群组 ID',
  fit_view: '适配窗口',
  fit_center: '适配中心',
  fit_tip: '看不见图？尝试执行下面两个功能',
  access_mode: '访问方式',
  all_groups: '所有组',
  collect_interval: '采集间隔',
  report_interval: '报告间隔',
  extension_config: '获取设备数据',
  data_synchronism: '数据同步',
  upload_file: '上传文件',
  device_data: '设备数据',
  delete_bind_info: '确认删除该标签吗？',
  delete_sub_device_info: '确认删除以下设备么？（操作不可回撤）',
  revoke: '撤销',
  delete_revoke_info: '确认撤销预期配置吗？',
  unbind_tip: '确认删除该标签吗？',
  delete_device_group_info: '确认要删除此设备组吗？',
  saving: '保存中',
  saved: '已保存',
  define_the_product: '定义产品',
  define_the_product_desc: '具有相同能力或特征的设备的合集被称为一款产品',
  register_the_device: '注册设备',
  register_the_device_desc: '设备创建身份，注册到平台的设备，才可以对设备进行管理',
  access_the_device: '设备接入',
  access_the_device_desc: '多种接入方式和接入场景，接入设备支持数据上报、管理控制等',
  create_a_data_pipeline: '创建数据管道',
  create_a_data_pipeline_desc: '通过数据管道，对边缘端以及云端数据进行清洗和预处理',
  configure_the_storage: '配置存储',
  configure_the_storage_desc: '完成数据策略配置，将数据根据实效分为不同的存储',
  analyze_the_data: '数据分析',
  analyze_the_data_desc: '对清洗过滤后的数据进行分析，有时序分析，实时分析等不同分析方式',
  process_guidance: '流程引导',
  latest_news: '最新动态',
  edge_cloud_rules: '边缘端规则',
  edge_cloud_rule: '边缘端规则',
  edge_cloud_rule_forwarding: '数据转发',
  edge_forwarding: '边缘端数据转发',
  rule_name: '规则名称',
  please_select: '请选择{type}名称',

  all_devices: '所有设备',
  immediate_delivery: '即时交货',
  these_two_secrets_do_not_match: '这两个密钥不匹配。',
  command_id: '命令 ID',
  command_name: '命令名称',
  total_products: '产品总数',
  total_devices: '设备总数',
  chart_graph: '图表',
  online_devices: '在线设备数',
  offline_devices: '离线设备数',
  deactivated_devices: '未激活设备数',
  used: '已使用',
  free: '未使用',
  product_unit: '个',
  device_unit: '台',
  report_content: '回報內容',
  mqtt_address: 'MQTT 地址',
  output_type: '输出类型',
  set_datasource: '设置数据源',
  set_output: '设置输出',
  old_style: '旧风格',
  new_style: '新风格',
  keywords: '关键字',
  extension_config_tip: '当前设备未设置扩展信息，请先设置设备扩展信息，扩展信息用于配置设备接入网关和设备模型定义之间的映射关系。',
  every_times: '每{time}',
  update_extension_config_sucessfully: '扩展信息更新成功',
  device_groups: 'Device Groups',
  more_kubeiot: '更多',
  discard: '丢弃',
  run: '运行',
  view_switch: '视图切换',
  ex_co_modules: '展开或收合所有模块',
  stream_status: '规则状态',
  create_forwarding_rule: '创建规则转发',
  set_cleaning_rule: '设置清洗规则',
  set_forwarding_target: '设置转发目标',
  run_rule: '启动规则',
  create_stream: '规则',
  worker_id: '端点ID',
  baudrate: '波特率',
  data_bits: '数据位',
  parity: '奇偶校验',
  stop_bit: '停止位',
  register: '寄存器类型',
  CoilRegister: '线圈寄存器',
  DiscreteInputRegister: '离散寄存器',
  InputRegister: '输入寄存器',
  HoldingRegister: '保持寄存器',
  offset: '寄存器地址',
  quantity: '数量',
  endianness: '字节序',
  timeout: '超时时间',
  BigEndian: '大端模式',
  BigEndianSwap: '大端交换模式',
  LittleEndian: '小端模式',
  LittleEndianSwap: '小端交换模式',
  device_extension_config: '设备扩展信息',
  property_extension_config: '属性扩展信息',
  command_extension_config: '命令扩展信息',
  event: '事件',
  no_config: '未配置',
  already_config: '已配置',
  request_data_type: '数据类型',
  request_item_type: '元素数据类型',
  device_protocol: '设备协议',
  inmmediate_delivery: '立即交付',
  unbinding: '解绑',
  report_channel: '设备通过MQTT通道上报消息，需要发送给指定的topic',
  report_format: '上报消息的topic格式：/devices/device_id/sys/properties/report',
  saved_successfully: '保存成功',
  run_stream: '运行规则',
  stop_stream: '停止规则',
  update_stream: '规则',

  // =======================           AutoIoTSuite        =======================
  synchronization: '同步'
};

export default zh_CN;
